export const API_URL = process.env.REACT_APP_API_URL;
export const MAP_KEY: any = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const STORAGE = "hubwallet-cmms";
export const KEYS = {
    AUTH_ACCESS: "hubwallet-auth-access",
    AUTH_REFRESH: "hubwallet-auth-refresh",
    REFRESH_TOKEN_EXPIRY: "hubwallet-refresh-expiry",
};
export const AI_REDIRECT_URL = process.env.REACT_APP_AI_REDIRECT_URL;
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN;

//#region URLs
export const URLS = {
    AUTH: {
        LOGIN: "/login",
        REGISTER: "/register",
        FORGOT_PASSWORD: (email: string | null = null) => {
            return email ? `/forgot-password/${email}` : "/forgot-password/:email";
        }
    },
    RESET_PASSWORD: "/reset-password",
    DASHBOARD: "/",
    ORDERS_AND_FULFILLMENT: {
        ALL_ORDERS: "/sales-and-fulfillment/all-sales",
        ORDER_DETAILS: (orderId: string | number | null = null) =>
            orderId ? `/sales-and-fulfillment/sale/details/${orderId}` : "/sales-and-fulfillment/sale/details/:orderId",
    },
    REPORTING: "/reporting",
    PROFILE: "/profile",
    PRODUCT_CATEGORIES: "/product-categories",
    CREATE_PRODUCT_CATEGORY: "/product-categories/create",
    EDIT_PRODUCT_CATEGORY: (id: string | null = null) => {
        return id ? `/product-categories/edit/${id}` : "/product-categories/edit/:id";
    },
    PRODUCTS: "/products",
    NON_TAXABLE_PRODUCTS: "/non-taxable-products",
    PRODUCT_DETAILS: "/products/:id",
    CREATE_PRODUCT: (productType: any = "") => `/products/${productType || ":type"}/create`,
    EDIT_PRODUCT: (productType: any = "", id: string | null = null) =>
        `/products/${productType || ":type"}/edit/${id || ":id"}`,
    DUPLICATE_PRODUCT: (productType: any = "", id: string | null = null) =>
        `/products/${productType || ":type"}/duplicate/${id || ":id"}`,
    PRODUCT_DISPLAY_ORDER: "/products/display-order",
    GIFT_CARDS_GENERAL: "/catalog/gift-cards/general",
    PHYSICAL_GIFT_CARDS: "/catalog/gift-cards/physical-inventory",
    GIFT_CARDS_HISTORY: "/catalog/gift-cards/history",
    GIFT_CARDS_OUTSTANDING_BALANCE: "/gift-cards/outstanding-balance",
    ORDER_CUSTOM_GIFT_CARD: "/gift-cards/order-custom",
    GIFT_CARDS: "/gift-cards",
    REORDER_GIFT_CARD: "/gift-cards/reorder",
    CONFIGURE_GIFT_CARD: (type: string | null = null, id: string | null = null) => {
        if (type && id) {
            return `/gift-cards/configure/${type}/edit/${id}`;
        } else if (type) {
            return `/gift-cards/configure/${type}`;
        } else {
            return id ? "/gift-cards/configure/:type/edit/:id" : "/gift-cards/configure/:type";
        }
    },
    EDIT_GIFT_CARD: (type: string | null = null, id: string | null = null) => {
        if (type && id) {
            return `/gift-cards/configure/${type}/edit/${id}`;
        } else {
            return "/gift-cards/configure/:type/edit/:id";
        }
    },
    UNITS: "/units",
    BRANDS: "/brands",
    TAGS: "/tags",
    VENDORS: "/vendors",
    CREATE_VENDOR: "/vendors/create",
    EDIT_VENDOR: (id: string | null = null) => {
        return id ? `/vendors/edit/${id}` : "/vendors/edit/:id";
    },
    ATTRIBUTES: "/attributes",
    CUSTOMERS: "/customers",
    DISCOUNT: "/discounts",
    CREATE_DISCOUNT: (discountType: any = "") => `/discounts/${discountType || ":type"}/create`,
    EDIT_DISCOUNT: (discountType: any = "", id: string | null = null) =>
        `/discounts/${discountType || ":type"}/edit/${id || ":id"}`,
    CUSTOMER_IMPORT: "/customer-import",
    CUSTOMER_GROUPS: "/customer-groups",
    CREATE_CUSTOMER_GROUP: (groupType: any = "") => `/customer-groups/${groupType || ":type"}/create`,
    EDIT_CUSTOMER_GROUP: (groupType: any = "", id: string | null = null) =>
        `/customer-groups/${groupType || ":type"}/edit/${id || ":id"}`,
    LOYALTY: "/loyalty",
    CREATE_LOYALTY: (loyaltyType: any = "") => `/loyalty/${loyaltyType || ":type"}/create`,
    EDIT_LOYALTY: (loyaltyType: any = "", id: string | null = null) =>
        `/loyalty/${loyaltyType || ":type"}/edit/${id || ":id"}`,
    LOYALTY_PROGRAM_INFO: "/loyalty/program-info",
    LOYALTY_REWARD: "/loyalty/reward",
    LOYALTY_BOARD: "/loyalty/loyalty-board",
    LOYALTY_ACTIVITY: "/activity",
    USER: "/users",
    USER_EMPLOYEE_TYPE: "/users/employee-type",
    USER_PAY_TYPE: "/users/pay-type",
    USER_ROLES: "/users/roles",
    CREATE_USER_ROLE: "/users/roles/create",
    EDIT_USER_ROLE: (id: string | null = null) => `/users/roles/edit/${id || ":id"}`,
    DUPLICATE_USER_ROLE: (id: string | null = null) => `/users/roles/duplicate/${id || ":id"}`,
    VIEW_USER_ROLE: (id: string | null = null) => `/users/roles/view/${id || ":id"}`,
    USER_MANAGE: "/users/manage-users",
    USER_SCHEDULE: "/users/user-schedule",
    USER_SCHEDULE_ADD:(id: string | null = null) => `/setup/users/schedule/${id || ":id"}`,
    USER_SCHEDULE_EDIT: (id: string | null = null) => `/setup/users/schedule/${id || ":id"}`,
    USER_ADD: "/users/create",
    USER_EDIT: (id: string | null = null) => `/users/edit/${id || ":id"}`,
    STOCK_CONTROL: "/stock-control",
    STOCK_CONTROL_ORDERS: "/inventory/stock-control/orders",
    STOCK_CONTROL_RECEIVE_ORDERS: "/inventory/stock-control/receive-orders",
    STOCK_CONTROL_TRANSFERS: "/inventory/stock-control/transfers",
    STOCK_CONTROL_VENDOR: "/inventory/stock-control/vendor-return",
    STOCK_CONTROL_VENDOR_RECEIVED: "/inventory/stock-control/vendor-received",
    STOCK_CONTROL_PENDING_RESTOCK: "/inventory/stock-control/pending-restock",
    STOCK_CONTROL_SENT_TO_REPAIRS: "/inventory/stock-control/sent-to-repairs",
    // STOCK_CONTROL_AUTO_GENERATE: "/stock-control/auto-generate",
    STOCK_CONTROL_EDIT_PO: (id: string | null = null, poType: string | null = null) =>
        `/stock-control/edit-po/${poType || ":poType"}/${id || ":id"}`,
    STOCK_CONTROL_NEW_PO: (poType: string | null = null) => `/stock-control/new-po/${poType || ":poType"}`,
    STOCK_CONTROL_PO_RECEIVE_ORDER: (id: string | null = null) => `/stock-control/orders/po-receive/${id || ":id"}`,
    STOCK_CONTROL_PO_RECEIVE_ORDER_EDIT: (id: string | null = null) =>
        `/stock-control/orders/po-receive/edit/${id || ":id"}`,
    STOCK_CONTROL_PO_RECEIVE_ORDER_DETAIL: (id: string | null = null) =>
        `/stock-control/orders/po-receive/detail/${id || ":id"}`,
    STOCK_CONTROL_RECEIVE_ORDER: "/stock-control/receive-order",
    STOCK_CONTROL_EDIT_RECEIVE_ORDER: (id: string | null = null) => `/stock-control/receive-order/edit/${id || ":id"}`,
    STOCK_CONTROL_PO_DETAIL: (id: string | null = null) => `/stock-control/orders/${id || ":id"}`,
    STOCK_CONTROL_RECEIVE_ORDER_DETAIL: (id: string | null = null) => `/stock-control/receive-order/${id || ":id"}`,
    STOCK_CONTROL_NEW_TRANSFER: "/stock-control/new-transfer",
    STOCK_CONTROL_EDIT_TRANSFER: (id: string | null = null) => `/stock-control/edit-transfer/${id || ":id"}`,
    STOCK_CONTROL_RECEIVE_TRANSFER: (id: string | null = null) => `/stock-control/receive-transfer/${id || ":id"}`,
    STOCK_CONTROL_NEW_RETURN: "/stock-control/new-return",
    STOCK_CONTROL_EDIT_RETURN: (id: string | null = null) => `/stock-control/edit-return/${id || ":id"}`,
    STOCK_CONTROL_RECEIVE_RETURN: (id: string | null = null) => `/stock-control/receive-return/${id || ":id"}`,
    STOCK_CONTROL_RECEIVE_RETURN_EDIT: (id: string | null = null) => `/stock-control/receive-return/edit/${id || ":id"}`,
    STOCK_CONTROL_RETURN_FROM_RO: "/stock-control/return-from-receive-order",
    INVENTORY_COUNTS: "/inventory-counts",
    CREATE_INVENTORY_COUNT: "/inventory-counts/create",
    EDIT_INVENTORY_COUNT: (id: string | null = null) => {
        return id ? `/inventory-counts/edit/${id}` : "/inventory-counts/edit/:id";
    },
    FULFILLMENTS: "/fulfillments",
    INVENTORY_COUNTS_START_COUNT: (id: string | null = null) => `/inventory-counts/start-count/${id || ":id"}`,
    SETTINGS_RETURN: "/settings/returns",
    SETTINGS: "/settings",
    SETUP: "/setup",
    ACTIVITY: "/setup/activity",
    NOTIFICATIONS_AND_REMINDERS: "/setup/notifications",
    SMS_NOTIFICATIONS: "/setup/notifications-reminder/text-messages",
    EMAIL_NOTIFICATIONS: "/setup/notifications-reminder/email-notifications",
    BUSINESS_PROFILE: "/setup/my-business/business-profile",
    STORE_LOCATIONS: "/setup/my-business/store-locations",
    WAREHOUSES: "/setup/my-business/warehouses",
    ONLINE_STORE: "/setup/my-business/online-store",
    PAYMENT_METHOD: "/setup/payment/payment-method",
    CREATE_PAYMENT_METHOD: "/setup/payment/payment-method/create",
    EDIT_PAYMENT_METHOD: (id: string | null = null) => `/setup/payment/payment-method/edit/${id || ":id"}`,
    DELIVERY_TEMPLATES: "/setup/template-preferences/delivery-templates",
    SHIPMENT_TEMPLATES: "/setup/template-preferences/shipment-templates",
    INVOICE_TEMPLATES: "/setup/template-preferences/invoice-templates",
    SALES_TEMPLATES: "/setup/template-preferences/sales-templates",
    RECEIPT_TEMPLATES: "/setup/template-preferences/receipt-templates",
    AGREEMENTS_AND_POLICIES: "/setup/agreements-and-policies",
    DEPOSITS: "/setup/deposits",
    STORE_CREDITS: "/store-credits",
    SALES_TAX: "/setup/all-taxes",
    DONATION: "/setup/donation",
    CASH_DISCOUNT: "/setup/pricing-and-payments",
    EBT_SETTINGS: "/setup/ebt-settings",
    TIP: "/setup/tip",
    QUICKBOOKS: "/setup/integration/quickbooks",
    SETTINGS_LANGUAGE: "/setup/language-settings",
    INVENTORY_STOCK_REPORT: "/reports/inventory-stock",
    INVENTORY_MOVEMENT_REPORT: "/reports/inventory-movement",
    REFUND_REPORT: "/reports/refund",
    SALES_REPORT: "/reports/sales",
    TIME_CARD_REPORT: "/reports/time-card",
    TIP_REPORT: "/reports/tip",
    TRANSACTION_REPORT: "/reports/transaction",
    EMPLOYEE_COMMISSION_REPORT: "/reports/employee-commission",
    SALES_BY_LOCATION_REPORT: "/reports/sales-by-location",
    SALE_BY_CATEGORY_REPORT: "/reports/sale-by-category",
    SALE_BY_PRODUCT_TYPE_REPORT: "/reports/sale-by-product-type",
    SALE_BY_PRODUCT_REPORT: "/reports/sale-by-product",
    SALES_BY_VENDOR_REPORT: "/reports/sales-by-vendor",
    SALE_BY_DISCOUNTS_REPORT: "/reports/sale-by-discounts",
    VOID_TRANSACTION_REPORT: "/reports/void-transaction",
    GROSS_PROFIT_REPORT: "/reports/gross-profit",
    NET_SALES_REPORT: "/reports/net-sales",
    RETURNS_REPORT: "/reports/returns",
    LOYALTY_PROGRAM_REPORT: "/reports/loyalty-program",
    STORE_CREDIT_REPORT: "/reports/store-credit",
    COGS_REPORT: "/reports/cost-of-goods-sold",
    TAX_REPORT: "/reports/tax-report",
    INVENTORY_SUMMARY_REPORT: "/reports/inventory-summary",
    SALE_BY_CUSTOMER_GROUP_REPORT: "/reports/sale-by-customer-group",
    RETURN_BY_VENDOR_REPORT: "/reports/return-by-vendor",
    TOP_SELLING_CATEGORY_REPORT: "/reports/top-selling-category",
    DEPOSIT_REPORT: "/reports/deposit-report",
    ADJUSTMENTS_REPORT: "/reports/adjustments",
    CART_DISCARDED_PRODUCT_REPORT: "/reports/cart-discarded-product",
    END_OF_DAY_COMPLIANCE_REPORT: "/reports/end-of-day",
    END_OF_SHIFT_REPORT: "/reports/end-of-shift",
    BATCH_CLOSE_REPORT: "/reports/batch-close",
    SALES_SUMMARY_REPORT: "/reports/sales-summary",
    CASH_DROP_REPORT: "/reports/cash-drop",
    CUSTOMER_FEEDBACK: `/customer-feedback`,
    IMPORT_PRODUCTS: `/import-products`,
    FEEDBACK_AND_RATINGS: `/feedback-and-ratings`,
    SSO_LOGIN: "/ai",
    LOTTERY: "/lottery",
    CREATE_LOTTERY: "/lottery/create",
    EDIT_LOTTERY: (id: string | null = null) => id ? `/lottery/edit/${id}` : "/lottery/edit/:id",
    LOTTERY_TICKETS: (id: string | null = null) => id ? `/lottery/tickets/${id}` : "/lottery/tickets/:id",

    // Marketing Automation
    MARKETING_CAMPAIGNS: "/marketing/campaigns",
    MARKETING_CAMPAIGN_CREATE: "/marketing/campaigns/new",
    MARKETING_CAMPAIGN_EDIT: (id?: string) => `/marketing/campaigns/edit/${id || ":id"}`,
    MARKETING_CAMPAIGN_DETAILS: (id?: string) => `/marketing/campaigns/${id || ":id"}`,
    MARKETING_AUDIENCE_LISTS: "/marketing/audience-lists",
    MARKETING_AUDIENCE_LIST_CREATE: "/marketing/audience-lists/new",
    MARKETING_AUDIENCE_LIST_EDIT: (id?: string) => `/marketing/audience-lists/edit/${id || ":id"}`,
    MARKETING_AUDIENCE_LIST_VIEW: (id?: string) => `/marketing/audience-lists/view/${id || ":id"}`,
    MARKETING_SETTINGS: "/marketing/settings",
};

//#region APIs
export const APIS = {
    AUTH: {
        LOGIN: API_URL + "/User/Login",
        LOGOUT: API_URL + "/User/Logout",
        FORGOT_PASSWORD: API_URL + "/User/ForgotPassword",
        RESET_PASSWORD: API_URL + "/User/ResetPassword",
   CHANGE_PASSWORD: API_URL + "/users/password",
        REGISTRATION: API_URL + "/register",
        AVATAR: API_URL + "/users/avatar",
        REFRESH_TOKEN: API_URL + "/User/RefreshToken",
    },
    USER: {
        GET_DESIGNS: API_URL + "/design/list",
        SAVE_DESIGN: API_URL + "/design/create",
        UPDATE_DESIGN: API_URL + "/design/update",
        IMAGE_LIST: API_URL + "/user-image/list",
        IMAGE_UPLOAD: API_URL + "/user-image/create",
        IMAGE_DELETE: API_URL + "/user-image/delete",
        MENUS: API_URL + "/User/AdminMenus",
        GET_USER_ACTIVITY: API_URL + "/User/GetUserActivity",
        LAST_PUNCH_STATUS: API_URL + "/User/LastPunchStatus",
        CLOCK_IN: API_URL + "/User/ClockIn",
    },

    COMMON: {
        GET_CITY: API_URL + "/City/GetCity",
        GET_STATE: API_URL + "/State/Get",
        GET_COUNTY: API_URL + "/County/Get",
        GET_COUNTRY: API_URL + "/Country/Get",
        LOOKUP_VALUES: API_URL + "/Lookup/Values",
        LOCATION_SEARCH: API_URL + "/Location/Search",
        GET_CURRENCY: API_URL + "/Currency/Get",
        GET_TIMEZONES: API_URL + "/TimeZone/Get",
    },
    CATEGORIES: {
        ADD_UPDATE_CATEGORY: API_URL + "/Category/InsertUpdateCategory",
        DELETE_CATEGORY: API_URL + "/Category/DeleteCategory",
        SEARCH_CATEGORY: API_URL + "/Category/Search",
        CATEGORY_DETAILS: API_URL + "/Category/Details/",
        REARRANGE_CATEGORY: API_URL + "/Category/CategoryDisplayOrder/Save",
    },
    UNITS: {
        SEARCH_UNIT: API_URL + "/UnitCatalog/Search",
        ADD_UPDATE_UNIT: API_URL + "/UnitCatalog/InsertUpdate",
        DELETE_UNIT: API_URL + "/UnitCatalog/Delete",
        UNIT_DETAILS: API_URL + "/UnitCatalog/Details/",
    },
    ATTRIBUTES: {
        SEARCH_ATTRIBUTE: API_URL + "/AttributeCatalog/Search",
        ADD_UPDATE_ATTRIBUTE: API_URL + "/AttributeCatalog/InsertUpdate",
        DELETE_ATTRIBUTE: API_URL + "/AttributeCatalog/Delete",
        ATTRIBUTE_DETAILS: API_URL + "/AttributeCatalog/Details/",
    },
    PRODUCTS: {
        SEARCH_PRODUCT: API_URL + "/Product/Search",
        ADD_UPDATE_PRODUCT: API_URL + "/Product/InsertUpdate",
        DELETE_PRODUCT: API_URL + "/Product/Delete",
        GENERATE_SKU: API_URL + "/Product/GenerateSKU",
        UPDATE_INVENTORY: API_URL + "/Product/UpdateInventory",
        UPDATE_PRICES: API_URL + "/Product/UpdatePrices",
        BULK_UPDATE_PRODUCTS: API_URL + "/Product/BulkInsertUpdate",
        STATUS_CHANGE: API_URL + "/Product/StatusChange",
        NON_TAXABLE_PRODUCT_SEARCH: API_URL + "/Product/NonTaxableProductSearch",
        ADD_NON_TAXABLE_PRODUCT: API_URL + "/Product/AddNonTaxableProduct",
        CHECK_SKU_UNIQUE: API_URL + "/Product/CheckSKUUnique",
        REARRANGE_PRODUCTS: API_URL + "/Product/ProductDisplayOrder/Save",
        ADMIN_POPULAR_PRODUCT_SEARCH: API_URL + "/Product/AdminPopularProductSearch",
        REARRANGE_POPULAR_PRODUCTS: API_URL + "/Product/PopularProductDisplayOrder/Save",
    },
    BUSINESS: {
        STORE_LOCATIONS_LIST: API_URL + "/Location/List",
        STORE_LOCATIONS_INSERT_UPDATE: API_URL + "/Location/InsertUpdate",
    },
    INVENTORY: {
        STOCK_TAKE_LIST: API_URL + "/StockTake/List",
        STOCK_TAKE_DELETE: API_URL + "/StockTake/Delete",
        STOCK_TRANSFER_SEARCH: API_URL + "/StockTransfer/Search",
        STOCK_TRANSFER_DELETE: API_URL + "/StockTransfer/Delete",
        SENT_TO_REPAIR_SEARCH: API_URL + "/PendingRestock/SentToRepairSearch",
        PENDING_RESTOCK_SEARCH: API_URL + "/PendingRestock/Search",
        PENDING_RESTOCK_INSERT_UPDATE: API_URL + "/PendingRestock/InsertUpdate",
        VENDOR_SEARCH: API_URL + "/VendorStockReturn/Search",
        SCHEDULE_INSERT_UPDATE: API_URL + "/StockTake/ScheduleInsertUpdate",
        STOCK_TAKE_DETAILS: API_URL + "/StockTake/Details/",
        VENDOR_STOCK_RETURN_SEARCH: API_URL + "/VendorStockReturn/Search",
        VENDOR_STOCK_RETURN_DELETE: API_URL + "/VendorStockReturn/Delete",
        VENDOR_STOCK_RETURN_DETAILS: API_URL + "/VendorStockReturn/Details",
        VENDOR_STOCK_RETURN_INSERT_UPDATE: API_URL + "/VendorStockReturn/InsertUpdate",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_SEARCH: API_URL + "/VendorStockReturn/ReceiveOrderSearch",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_INSERT_UPDATE: API_URL + "/VendorStockReturn/ReceiveOrderInsertUpdate",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_DETAILS: API_URL + "/VendorStockReturn/ReceiveOrderDetails/",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_DELETE: API_URL + "/VendorStockReturn/ReceiveOrderDelete",
        VENDOR_STOCK_RETURN_STATUS_CHANGE: API_URL + "/VendorStockReturn/ReturnStatusChange",
        INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER: API_URL + "/StockTransfer/WithinLocationTransfer",
        STOCK_TRANSFER_DETAILS: API_URL + "/StockTransfer/Details",
        PREFERRED_VENDORS: API_URL + "/PurchaseOrder/PreferredVendors",
        AUTO_PO_UNASSIGNED_PRODUCTS: API_URL + "/PurchaseOrder/AutoPOUnassignedProducts",
        AUTO_PO_VENDOR_PRODUCTS: API_URL + "/PurchaseOrder/AutoPOVendorProducts",
        MANUAL_PO_UNASSIGNED_PRODUCTS: API_URL + "/PurchaseOrder/ManualPOUnassignedProducts",
        MANUAL_PO_VENDOR_PRODUCTS: API_URL + "/PurchaseOrder/ManualPOVendorProducts",
        INSERT_UPDATE_PO: API_URL + "/PurchaseOrder/InsertUpdate",
        CHANGE_VENDOR: API_URL + "/PurchaseOrder/ChangeVendor",
        PURCHASE_ORDER_SEARCH: API_URL + "/PurchaseOrder/Search",
        PURCHASE_ORDER_DETAILS: API_URL + "/PurchaseOrder/Details/",
        PURCHASE_ORDER_DELETE: API_URL + "/PurchaseOrder/Delete",
        PURCHASE_ORDER_STATUS_CHANGE: API_URL + "/PurchaseOrder/PurchaseOrderStatusChange",
        RECEIVE_ORDER_SEARCH: API_URL + "/PurchaseOrder/ReceiveOrderSearch",
        RECEIVE_ORDER_INSERT_UPDATE: API_URL + "/PurchaseOrder/ReceiveOrderInsertUpdate",
        RECEIVE_ORDER_DETAILS: API_URL + "/PurchaseOrder/ReceiveOrderDetails/",
        RECEIVE_ORDER_DELETE: API_URL + "/PurchaseOrder/ReceiveOrderDelete",
        SEND_EMAIL_TO_VENDOR: API_URL + "/PurchaseOrder/SendEmailToVendor",
        INBOUND_ORDER_QTY: API_URL + "/PurchaseOrder/InboundOrderQty",
        STOCK_COUNT_DETAILS: API_URL + "/StockTake/CountDetails/",
        START_STOCK_COUNT: API_URL + "/StockTake/Start",
        COMPLETE_STOCK_COUNT: API_URL + "/StockTake/Complete",
        CHANGE_STOCK_COUNT_STATUS: API_URL + "/StockTake/StatusChange",
        INSERT_PRODUCT: API_URL + "/StockTake/CountProductInsert",
        RECEIVE_STOCK_TRANSFER: API_URL + "/StockTransfer/ReceiveStockTransfer",
        PRODUCT_INVENTORY_INSIGHT: API_URL + "/Product/InventoryInsight",
    },
    LOYALTY_REWARD: {
        LIST: API_URL + "/LoyaltyReward/List",
        DETAILS: API_URL + "/LoyaltyReward/Details",
        INSERT_UPDATE: API_URL + "/LoyaltyReward/InsertUpdate",
        DELETE: API_URL + "/LoyaltyReward/Delete",
    },
    BRANDS: {
        SEARCH_BRAND: API_URL + "/Brand/Search",
        ADD_UPDATE_BRAND: API_URL + "/Brand/InsertUpdate",
        DELETE_BRAND: API_URL + "/Brand/Delete",
        BRAND_DETAILS: API_URL + "/Brand/Details/",
    },
    TAGS: {
        SEARCH_TAG: API_URL + "/TagCatalog/Search",
        ADD_UPDATE_TAG: API_URL + "/TagCatalog/InsertUpdate",
        DELETE_TAG: API_URL + "/TagCatalog/Delete",
        TAG_DETAILS: API_URL + "/TagCatalog/Details/",
    },
    VENDORS: {
        SEARCH_VENDOR: API_URL + "/Vendor/Search",
        ADD_UPDATE_VENDOR: API_URL + "/Vendor/InsertUpdate",
        DELETE_VENDOR: API_URL + "/Vendor/Delete",
        VENDOR_DETAILS: API_URL + "/Vendor/Details/",
        CHECK_SKU_UNIQUE: API_URL + "/Vendor/CheckSKUUnique",
    },
    CUSTOMERS: {
        LIST_CUSTOMER: API_URL + "/Customer/List",
        SEARCH_CUSTOMER: API_URL + "/Customer/Search",
        CUSTOMER_DETAILS: API_URL + "/Customer/Details/",
        ADD_UPDATE_CUSTOMER: API_URL + "/Customer/InsertUpdate",
        DELETE_CUSTOMER: API_URL + "/Customer/Delete",
        IMPORT_CUSTOMERS: API_URL + "/Import/CustomerImport",
        LIST_CUSTOMER_GROUPS: API_URL + "/CustomerGroup/Get",
        DELETE_CUSTOMER_GROUP: API_URL + "/CustomerGroup/Delete",
        ADD_UPDATE_CUSTOMER_GROUP: API_URL + "/CustomerGroup/InsertUpdate",
        CUSTOMER_GROUP_RULE_MASTER: API_URL + "/CustomerGroup/RuleMaster",
        SEARCH_CUSTOMER_GROUPS: API_URL + "/CustomerGroup/Details/",
        ADD_UPDATE_CUSTOMER_GROUP_CUSTOM: API_URL + "/CustomerGroup/CustomGroupInsertUpdate",
        GET_CUSTOMER_PROMOTIONS: API_URL + "/Customer/Promotion/",
    },
    STORAGE: {
        UPLOAD_IMAGE: API_URL + "/Storage/UploadImage",
    },
    DISCOUNTS: {
        SEARCH_DISCOUNT: API_URL + "/Discount/Search",
        ADD_UPDATE_DISCOUNT: API_URL + "/Discount/InsertUpdate",
        DELETE_DISCOUNT: API_URL + "/Discount/Delete",
    },
    LOYALTY: {
        GET_LOYALTY: API_URL + "/Loyalty/Get",
        LOYALTY_DETAILS: API_URL + "/Loyalty/Details/",
        ADD_UPDATE_LOYALTY: API_URL + "/Loyalty/InsertUpdate",
        DELETE_LOYALTY: API_URL + "/Loyalty/Delete",
        ACTIVITY_SEARCH: API_URL + "/Loyalty/ActivitySearch",
        GET_AVG_CUSTOMER_SPEND: API_URL + "/LoyaltyDashboard/GetAvgCustomerSpend/",
        GET_LOYALTY_SALES: API_URL + "/LoyaltyDashboard/GetSalesSummary/",
        GET_TOP_CUSTOMERS: API_URL + "/LoyaltyDashboard/GetTopCustomers/",
        GET_CUSTOMER_VISITS: API_URL + "/LoyaltyDashboard/GetCustomerVisit/",
        GET_REWARDS_DATA: API_URL + "/LoyaltyDashboard/GetReward/",
    },
    GIFT_CARDS: {
        CATEGORY_INSERT_UPDATE: API_URL + "/GiftCardCategory/InsertUpdate",
        CATEGORY_DETAILS_BY_ID: API_URL + "/GiftCardCategory/DetailsById",
        CATEGORY_SEARCH: API_URL + "/GiftCardCategory/Search",
        INSERT_UPDATE: API_URL + "/GiftCardCategory/ConfigurationInsertUpdate",
        SEARCH: API_URL + "/GiftCardCategory/ConfigurationSearch",
        CATEGORY_LIST: API_URL + "/GiftCardCategory/CategoryList",
        PHYSICAL_GIFT_CARD_SEARCH: API_URL + "/GiftCardCategory/PhysicalGiftCardSearch",
        HISTORY_SEARCH: API_URL + "/GiftCardCategory/HistorySearch",
        GENERAL_GIFT_CARD_SEARCH: API_URL + "/GiftCardCategory/GeneralGiftCardSearch",
    },
    SETTINGS_RETURN: {
        SETTING_RETURN_INSERT_UPDATE: API_URL + "/ReturnPolicy/InsertUpdate",
        GET_SETTING_RETURN_POLICY: API_URL + "/ReturnPolicy/Details",
    },
    NOTIFICATIONS: {
        GET_NOTIFICATION_REMINDERS: API_URL + "/SettingsNotificationReminder/Get",
        INSERT_UPDATE_NOTIFICATION_REMINDERS: API_URL + "/SettingsNotificationReminder/InsertUpdate",
    },
    USER_MANAGEMENT: {
        //employee types
        GET_EMPLOYEE_TYPES: API_URL + "/EmployeeType/GetList",
        UPDATE_EMPLOYEE_TYPES: API_URL + "/EmployeeType/InsertUpdate",
        DELETE_EMPLOYEE_TYPES: API_URL + "/EmployeeType/Delete",

        //pay types
        GET_PAY_TYPES: API_URL + "/PayType/GetList",
        UPDATE_PAY_TYPES: API_URL + "/PayType/InsertUpdate",
        DELETE_PAY_TYPES: API_URL + "/PayType/Delete",

        //users
        SEARCH_USERS: API_URL + "/User/Search",
        INSERT_UPDATE_USER: API_URL + "/User/InsertUpdate",
        DELETE_USER: API_URL + "/User/Delete",
        GET_USER_DETAILS: API_URL + "/User/Details/",
        GET_USER_SCHEDULE: API_URL + "/User/GetUserSchedule",
        SEARCH_USER_SCHEDULE: API_URL + "/User/UserScheduleSearch",
        INSERT_UPDATE_USER_SCHEDULE: API_URL + "/User/UserScheduleInsertUpdate",
        GET_USER_SCHEDULE_BY_ID: API_URL + "/User/UserScheduleGetByID",
        VALIDATE_MPIN: API_URL + "/User/ValidateMPin",

        //role permissions
        GET_ROLE_PERMISSION: API_URL + "/RolePermission/Detail",
        ROLE_LIST: API_URL + "/RolePermission/RoleList",
        INSERT_UPDATE_ROLE_PERMISSION: API_URL + "/RolePermission/InsertUpdate",
        DELETE_ROLE_PERMISSION: API_URL + "/RolePermission/Delete",
    },

    //orders and fulfillment
    ORDERS_AND_FULFILLMENT: {
        GET_SEARCH_ORDERS: API_URL + "/Order/FulfillmentSearch",
        GET_ORDER_DETAILS: API_URL + "/Order/fulfillment/",
        GET_RETURN_ORDER_DETAILS: API_URL + "/Order/ReturnOrderDetails",
    },
    SETTINGS_PAYMENT_TYPE: {
        MASTER_GET: API_URL + "/SettingsPaymentType/MasterGet",
        GET: API_URL + "/SettingsPaymentType/Get",
        INSERT_UPDATE: API_URL + "/SettingsPaymentType/InsertUpdate",
        DETAILS_BY_ID: API_URL + "/SettingsPaymentType/DetailsById",
        DELETE: API_URL + "/SettingsPaymentType/Delete",
        STATUS_CHANGE: API_URL + "/SettingsPaymentType/StatusChange",
    },
    SETTINGS: {
        STORE_CREDIT_GET: API_URL + "/SettingsStoreCredit/Get",
        STORE_CREDIT_INSERT_UPDATE: API_URL + "/SettingsStoreCredit/InsertUpdate",
    },
    TAX: {
        REFRESH_COMPANY_RATES: API_URL + "/Tax/RefreshCompanyRates",
        GET_RATE: API_URL + "/Tax/Rate",
        RATE_BULK: API_URL + "/Tax/RateBulk",
        ADDITIONAL_TAX_LIST: API_URL + "/AdditionalTax/Search",
        ADDITIONAL_TAX_INSERT_UPDATE: API_URL + "/AdditionalTax/InsertUpdate",
        ADDITIONAL_TAX_DETAILS: API_URL + "/AdditionalTax/Details/",
        ADDITIONAL_TAX_DELETE: API_URL + "/AdditionalTax/Delete",
    },
    DONATION: {
        GET: API_URL + "/SettingsDonation/Get",
        INSERT_UPDATE: API_URL + "/SettingsDonation/InsertUpdate",
    },
    CASH_DISCOUNT: {
        GET: API_URL + "/SettingsCashDiscountDualPrice/pricing-settings",
        INSERT_UPDATE: API_URL + "/SettingsCashDiscountDualPrice/extra-settings",
    },
    TIP: {
        GET: API_URL + "/SettingsTip/Get",
        INSERT_UPDATE: API_URL + "/SettingsTip/InsertUpdate",
    },
    CONSENT: {
        GET_CONTENT: API_URL + "/Consent/Content",
        GET_MERCHANT: API_URL + "/Consent/Merchant",
        ACCEPT_MERCHANT: API_URL + "/Consent/Merchant/Accept",
        GET_SMS_PREFERENCE: API_URL + "/User/SmsPreference",
        SAVE_SMS_PREFERENCE: API_URL + "/User/SmsPreference",
    },
    SETTINGS_LANGUAGE: {
        GET: API_URL + "/SettingsLanguage/Get",
        SAVE: API_URL + "/SettingsLanguage/Save",
    },
    SETTINGS_MANUAL_PRODUCT_TAXABLE: {
        GET: API_URL + "/SettingsManualProductTaxable/Get",
        SAVE: API_URL + "/SettingsManualProductTaxable/Save",
    },
    ADDITIONAL_TAX: {
        GET_APPLICABLE: API_URL + "/AdditionalTax/GetApplicable",
        PRODUCT_LOCATION_TAXES: API_URL + "/products",
    },
    AGREEMENT_POLICIES: {
        GET_AGREEMENT_POLICIES: API_URL + "/SettingsAgreementPolicy/Get",
        DELETE_AGREEMENT_POLICY: API_URL + "/SettingsAgreementPolicy/Delete",
        INSERT_UPDATE_POLICY: API_URL + "/SettingsAgreementPolicy/InsertUpdate",
        GET_POLICY_BY_ID: API_URL + "/SettingsAgreementPolicy/DetailsById",
    },
    REPORTING: {
        REFUND_REPORT: API_URL + "/Report/Refund",
        SALES_REPORT: API_URL + "/Report/Sales",
        TIME_CARDS_REPORT: API_URL + "/Report/TimeCards",
        TIP_REPORT: API_URL + "/Report/Tips",
        INVENTORY_MOVEMENT_REPORT: API_URL + "/Report/InventoryMovement",
        INVENTORY_STOCK_REPORT: API_URL + "/Report/InventoryStock",
        TRANSACTION_REPORT: API_URL + "/Report/Transactions",
        COMMISSION_REPORT: API_URL + "/Report/Commission",
        SALES_BY_LOCATION: API_URL + "/Report/SalesByLocation",
        SALES_BY_CATEGORY: API_URL + "/Report/SalesByCategory",
        SALES_BY_PRODUCT_TYPE: API_URL + "/Report/SalesByProductType",
        SALES_BY_PRODUCT: API_URL + "/Report/SalesByProduct",
        SALES_BY_VENDOR: API_URL + "/Report/SalesByVendor",
        SALES_BY_DISCOUNT: API_URL + "/Report/SalesByDiscount",
        VOID_TRANSACTION: API_URL + "/Report/CastlePayVoid",
        PO_TERMINALS: API_URL + "/Report/POTerminals",
        GROSS_PROFIT: API_URL + "/Report/GrossProfit",
        NET_SALES: API_URL + "/Report/NetSales",
        RETURNS: API_URL + "/Report/Returns",
        LOYALTY_PROGRAM: API_URL + "/Report/LoyaltyProgram",
        STORE_CREDIT: API_URL + "/Report/StoreCreditReport",
        COGS: API_URL + "/Report/COGS",
        TAX: API_URL + "/Report/Tax",
        INVENTORY_SUMMARY: API_URL + "/Report/InventorySummary",
        SALES_BY_CUSTOMER_GROUP: API_URL + "/Report/SalesByCustomerGroup",
        RETURN_BY_VENDOR: API_URL + "/Report/ReturnByVendor",
        TOP_SELLING_CATEGORY: API_URL + "/Report/TopSellingCategory",
        STOCK_ADJUSTMENT: API_URL + "/Report/StockAdjustment",
        DEPOSIT_REPORT: API_URL + "/Report/Deposit",
        CART_DISCARDED_PRODUCT: API_URL + "/Report/CartDiscardedProduct",
        END_OF_DAY: API_URL + "/Report/EODCompliance",
        CASH_REGISTER_CLOSE: API_URL + "/Report/CashRegisterClose",
        BATCH_CLOSE_REPORT: API_URL + "/Batch/BatchClosePreviousReport",
        SALES_SUMMARY: API_URL + "/Report/SalesSummary",
        CASH_DROP_REPORT: API_URL + "/Report/CashDropHistory",
    },
    TEMPLATE: {
        GET_MESSAGE_TEMPLATE: API_URL + "/SettingsMessageTemplate/Get",
        INSERT_UPDATE_MESSAGE_TEMPLATE: API_URL + "/SettingsMessageTemplate/InsertUpdate",
        GET_EMAIL_TEMPLATE: API_URL + "/SettingsEmailTemplate/Get",
        INSERT_UPDATE_EMAIL_TEMPLATE: API_URL + "/SettingsEmailTemplate/InsertUpdate",
    },
    COMPANY: {
        GET_COMPANY_DETAILS: API_URL + "/Company/Details",
        UPDATE_COMPANY_DETAILS: API_URL + "/Company/Update",
    },
    RECEIPT_TEMPLATE: {
        INSERT_UPDATE: API_URL + "/ReceiptTemplate/InsertUpdate",
        DETAILS_BY_ID: API_URL + "/ReceiptTemplate/DetailsById",
    },
    FEEDBACK: {
        GET_CUSTOMER_FEEDBACK_DETAILS: API_URL + "/Feedback/CustomerFeedbackDetails/",
        INSERT_FEEDBACK: API_URL + "/Feedback/Insert",
        GET_FEEDBACK_LIST: API_URL + "/Feedback/list",
        GET_SETTINGS: API_URL + "/Feedback/Settings",
        SAVE_SETTINGS: API_URL + "/Feedback/Settings/Save",
    },
    PRODUCT_IMPORT: {
        IMPORT_PRODUCTS: API_URL + "/ProductImport/ProductImport",
    },
    DASHBOARD: {
        GET_TOTAL_REVENUE: API_URL + "/Dashboard/GetRevenueTotal",
        GET_AVG_SALES_TICKET: API_URL + "/Dashboard/GetAvgSalesTicket",
        GET_EXPENSE_TOTAL: API_URL + "/Dashboard/GetExpenseTotal",
        GET_GROSS_MARGIN_PERCENTAGE: API_URL + "/Dashboard/GetGrossMarginPercentage/v2",
        GET_ONLINE_VS_OFFLINE: API_URL + "/Dashboard/GetOnlineVsOffline",
        GET_REPEAT_CUSTOMER_PERCENTAGE: API_URL + "/Dashboard/GetRepeatCustomerPercentage",
        GET_GROSS_MARGIN_CHART: API_URL + "/Dashboard/GetGrossMargin",
        GET_REVENUE_EXPENSE_CHART: API_URL + "/Dashboard/GetRevenueExpenses",
        GET_PURCHASE_COST_CHART: API_URL + "/Dashboard/GetPurchaseCost",
        GET_SALES_VOLUME_CHART: API_URL + "/Dashboard/GetSalesVolume",
        GET_TOP_PRODUCTS: API_URL + "/Dashboard/GetTopProducts",
        GET_TOP_PROMOTIONS: API_URL + "/Dashboard/GetTopPromotions",
        GET_TOP_CATEGORIES: API_URL + "/Dashboard/GetTopCategories",
        GET_TOP_SALES_PERSON: API_URL + "/Dashboard/GetTopSalesPerson",
        GET_EMPLOYEE_WORK_TIME: API_URL + "/Dashboard/GetEmployeeWorkTime",
        GET_CUSTOMER_COMPARISON: API_URL + "/Dashboard/GetCustomerComparison",
        GET_AVG_SALES_TICKET_COMPARISON: API_URL + "/Dashboard/GetAvgSalesTicketComparison",
        GET_REPEAT_CUSTOMER_COMPARISON: API_URL + "/Dashboard/GetRepeatCustomerComparison",
        GET_GROSS_SALES_NET_SALES_CHART: API_URL + "/Dashboard/GetGrossSalesNetSales/v2",
        GET_GROSS_COST_LABOR_COST_CHART: API_URL + "/Dashboard/GetGrossCostLaborCost/v2",
        GET_RETURNS_REFUNDS_TREND: API_URL + "/Dashboard/GetReturnsRefundsTrend/v2",
        GET_VOIDS_CANCELLATIONS: API_URL + "/Dashboard/GetVoidsCancellations/v2",
        GET_TRANSACTION_VOLUME: API_URL + "/Dashboard/GetTransactionVolume/v2",
        GET_SALES_BY_PAYMENT_METHOD: API_URL + "/Dashboard/GetSalesByPaymentMethod/v2",
        GET_POINTS_ISSUED_BY_LOYALTY_TYPE: API_URL + "/Dashboard/GetPointsIssuedByLoyaltyType/v2",
        GET_SALES_TREND_BY_HOUR: API_URL + "/Dashboard/GetSalesTrendByHour/v2",
        GET_SALES_BREAKDOWN: API_URL + "/Dashboard/GetSalesBreakdown/v2",
        GET_POINTS_REDEEMED_BY_LOYALTY_TYPE: API_URL + "/Dashboard/GetPointsRedeemedByLoyaltyType/v2",
        GET_PARTICIPATION_RATE_BY_LOYALTY_TYPE: API_URL + "/Dashboard/GetParticipationRateByLoyaltyType/v2",
        GET_GROSS_SALES: API_URL + "/Dashboard/GetGrossSales/v2",
        GET_NET_SALES: API_URL + "/Dashboard/GetNetSales/v2",
        GET_COST_OF_GOODS_SOLD: API_URL + "/Dashboard/GetCostOfGoodsSold/v2",
        GET_GROSS_MARGIN: API_URL + "/Dashboard/GetGrossMargin",
        GET_LABOR_COST: API_URL + "/Dashboard/GetLaborCostPercentage/v2",
        GET_NUM_OF_TRANSACTIONS: API_URL + "/Dashboard/GetNumOfTransactions/v2",
        GET_LOW_PERFORMING_PRODUCTS: API_URL + "/Dashboard/GetLowPerformingProducts/v2",
    },

    // Marketing Automation
    MARKETING_CAMPAIGN: {
        SEARCH: API_URL + "/MarketingCampaign/Search",
        INSERT_UPDATE: API_URL + "/MarketingCampaign/InsertUpdate",
        DELETE: API_URL + "/MarketingCampaign/Delete",
        DETAILS: API_URL + "/MarketingCampaign/Details/",
        DELIVERIES: API_URL + "/MarketingCampaign/Deliveries",
    },
    MARKETING_AUDIENCE_LIST: {
        SEARCH: API_URL + "/MarketingAudienceList/Search",
        INSERT_UPDATE: API_URL + "/MarketingAudienceList/InsertUpdate",
        DELETE: API_URL + "/MarketingAudienceList/Delete",
        DETAILS: API_URL + "/MarketingAudienceList/Details/",
        BULK_UPSERT_MEMBERS: API_URL + "/MarketingAudienceList/BulkUpsertMembers",
        ADD_FROM_GROUPS: API_URL + "/MarketingAudienceList/AddFromGroups/",
    },
    MARKETING: {
        MASTER_TAGS: API_URL + "/Marketing/MasterTags",
        VALIDATE_TAGS: API_URL + "/Marketing/ValidateTags",
        PREVIEW_CONTENT: API_URL + "/Marketing/PreviewContent",
        GET_SETTINGS: API_URL + "/Marketing/Settings",
        SAVE_EMAIL_SETTINGS: API_URL + "/Marketing/Settings/Email",
        SAVE_SMS_SETTINGS: API_URL + "/Marketing/Settings/Sms",
    },
    LOTTERY: {
        SEARCH: API_URL + "/Lottery/Search",
        DETAILS: API_URL + "/Lottery/Details/",
        INSERT_UPDATE: API_URL + "/Lottery/InsertUpdate",
        DELETE: API_URL + "/Lottery/Delete",
        TICKET_SEARCH: API_URL + "/Lottery/TicketSearch",
        TICKET_EXPORT: API_URL + "/Lottery/TicketExport",
        BOOKLET_DELETE: API_URL + "/Lottery/BookletDelete",
        CHECK_BOOKLET_UNIQUE: API_URL + "/Lottery/CheckBookletNoUnique",
        LOOKUP_BARCODE: API_URL + "/Lottery/LookupBarcode/v2",
        BOOKLET_PARSED_ADD: API_URL + "/Lottery/BookletParsedAdd/v2",
    },
    DEPOSITS: {
        GET: API_URL + "/Deposit",
        ADD: API_URL + "/Deposit",
        UPDATE: API_URL + "/Deposit",
        DELETE: API_URL + "/Deposit/",
    },
    QUICKBOOKS: {
        SETUP_STATUS: API_URL + "/QuickBooks/Setup/Status",
        SAVE_SETUP: API_URL + "/QuickBooks/Setup/Save",
        CONNECT: API_URL + "/QuickBooks/Connect",
        DISCONNECT: API_URL + "/QuickBooks/Disconnect",
        DELETE_SETUP: API_URL + "/QuickBooks/Setup/Delete",
        MANUAL_SYNC_STATUS: API_URL + "/QuickBooks/ManualSync/Status",
        MANUAL_SYNC_TRIGGER: API_URL + "/QuickBooks/ManualSync/Trigger",
        MANUAL_SYNC_LOG: API_URL + "/QuickBooks/ManualSync/Log",
        MANUAL_SYNC_RETRY: API_URL + "/QuickBooks/ManualSync/Retry",
        OUTBOX_STATUS: API_URL + "/QuickBooks/SyncStatus",
        OUTBOX_LOG: API_URL + "/QuickBooks/SyncLog",
        OUTBOX_RETRY: API_URL + "/QuickBooks/SyncRetry/",
        OUTBOX_RETRY_ALL: API_URL + "/QuickBooks/SyncRetryAll",
    },
};

//#region ACTIONs
export const ACTIONS = {
    RESET_REDUCER: "ACTIONS/RESET_REDUCER",
    DIALOG: "ACTIONS/DIALOG",
    LOADER: {
        FP_STATUS: "ACTIONS/LOADER/FP_STATUS",
        MENU_COLLAPSE: "ACTIONS/LOADER/MENU_COLLAPSE",
        SEARCHING: "ACTIONS/LOADER/SEARCHING",
    },
    MASTER: {
        COUNTRY: "ACTIONS/MASTER/COUNTRY",
        STATES: "ACTIONS/MASTER/STATES",
        COUNTY: "ACTIONS/MASTER/COUNTY",
        CITY: "ACTIONS/MASTER/CITY",
        LOOKUP_VALUES: "ACTIONS/MASTER/LOOKUP_VALUES",
        TIMEZONES: "ACTIONS/MASTER/TIMEZONES",
        RETURN_REASONS: "ACTIONS/MASTER/RETURN_REASONS",
    },

    USER: {
        LOGIN: "ACTIONS/USER/LOGIN",
        USER: "ACTIONS/USER/USER",
        LOGOUT: "ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "ACTIONS/USER/RESET_PASSWORD",
        PASSWORD_RESET: "ACTIONS/USER/PASSWORD_RESET",
        MENUS: "ACTIONS/USER/MENUS",
        MENU_PERMISSIONS: "ACTIONS/USER/MENU_PERMISSIONS",
        UPDATE_TOKENS: "ACTIONS/USER/UPDATE_TOKENS",
    },
    CATEGORIES: {
        GET_CATEGORIES_LIST: "ACTIONS/CATEGORIES/GET_CATEGORIES_LIST",
        ADD_UPDATE_CATEGORY: "ACTIONS/CATEGORIES/ADD_UPDATE_CATEGORY",
        DELETE_CATEGORY: "ACTIONS/CATEGORIES/DELETE_CATEGORY",
        SEARCH_CATEGORY: "ACTIONS/CATEGORIES/SEARCH_CATEGORY",
        CATEGORY_DETAILS: "ACTIONS/CATEGORIES/CATEGORY_DETAILS",
        LOCATION_SEARCH: "ACTIONS/CATEGORIES/LOCATION_SEARCH",
        GET_CURRENCY: "ACTIONS/CATEGORIES/GET_CURRENCY",
        GET_TIMEZONES: "ACTIONS/CATEGORIES/GET_TIMEZONES",
        REARRANGE_CATEGORY: "ACTIONS/CATEGORIES/REARRANGE_CATEGORY",
    },
    UNITS: {
        SEARCH_UNIT: "ACTIONS/UNITS/SEARCH_UNIT",
        ADD_UPDATE_UNIT: "ACTIONS/UNITS/ADD_UPDATE_UNIT",
        DELETE_UNIT: "ACTIONS/UNITS/DELETE_UNIT",
        UNIT_DETAILS: "ACTIONS/UNITS/UNIT_DETAILS",
    },
    BRANDS: {
        SEARCH_BRAND: "ACTIONS/BRANDS/SEARCH_BRAND",
        ADD_UPDATE_BRAND: "ACTIONS/BRANDS/ADD_UPDATE_BRAND",
        DELETE_BRAND: "ACTIONS/BRANDS/DELETE_BRAND",
        BRAND_DETAILS: "ACTIONS/BRANDS/BRAND_DETAILS",
    },
    ATTRIBUTES: {
        SEARCH_ATTRIBUTE: "ACTIONS/ATTRIBUTES/SEARCH_ATTRIBUTE",
        ADD_UPDATE_ATTRIBUTE: "ACTIONS/ATTRIBUTES/ADD_UPDATE_ATTRIBUTE",
        DELETE_ATTRIBUTE: "ACTIONS/ATTRIBUTES/DELETE_ATTRIBUTE",
        ATTRIBUTE_DETAILS: "ACTIONS/ATTRIBUTES/ATTRIBUTE_DETAILS",
    },
    PRODUCTS: {
        SEARCH_PRODUCT: "ACTIONS/PRODUCTS/SEARCH_PRODUCT",
        ADD_UPDATE_PRODUCT: "ACTIONS/PRODUCTS/ADD_UPDATE_PRODUCT",
        GENERATE_SKU: "ACTIONS/PRODUCTS/GENERATE_SKU",
        UPDATE_INVENTORY: "ACTIONS/PRODUCTS/UPDATE_INVENTORY",
        UPDATE_PRICES: "ACTIONS/PRODUCTS/UPDATE_PRICES",
        BULK_UPDATE_PRODUCTS: "ACTIONS/PRODUCTS/BULK_UPDATE_PRODUCTS",
        SET_PRODUCT_FILTERS: "ACTIONS/PRODUCTS/SET_PRODUCT_FILTERS",
        CLEAR_PRODUCT_FILTERS: "ACTIONS/PRODUCTS/CLEAR_PRODUCT_FILTERS",
        REARRANGE_PRODUCTS: "ACTIONS/PRODUCTS/REARRANGE_PRODUCTS",
        ADMIN_POPULAR_PRODUCT_SEARCH: "ACTIONS/PRODUCTS/ADMIN_POPULAR_PRODUCT_SEARCH",
        REARRANGE_POPULAR_PRODUCTS: "ACTIONS/PRODUCTS/REARRANGE_POPULAR_PRODUCTS",
    },
    TAGS: {
        SEARCH_TAG: "ACTIONS/TAGS/SEARCH_TAG",
        ADD_UPDATE_TAG: "ACTIONS/TAGS/ADD_UPDATE_TAG",
        DELETE_TAG: "ACTIONS/TAGS/DELETE_TAG",
        TAG_DETAILS: "ACTIONS/TAGS/TAG_DETAILS",
    },
    VENDORS: {
        SEARCH_VENDOR: "ACTIONS/VENDORS/SEARCH_VENDOR",
        ADD_UPDATE_VENDOR: "ACTIONS/VENDORS/ADD_UPDATE_VENDOR",
        DELETE_VENDOR: "ACTIONS/VENDORS/DELETE_VENDOR",
        VENDOR_DETAILS: "ACTIONS/VENDORS/VENDOR_DETAILS",
    },
    CUSTOMERS: {
        LIST_CUSTOMER: "ACTIONS/CUSTOMERS/LIST_CUSTOMER",
        SEARCH_CUSTOMER: "ACTIONS/CUSTOMERS/SEARCH_CUSTOMER",
        CUSTOMER_DETAILS: "ACTIONS/CUSTOMERS/CUSTOMER_DETAILS",
        ADD_UPDATE_CUSTOMER: "ACTIONS/CUSTOMERS/ADD_UPDATE_CUSTOMER",
        DELETE_CUSTOMER: "ACTIONS/CUSTOMERS/DELETE_CUSTOMER",
        IMPORT_CUSTOMERS: "ACTIONS/CUSTOMERS/IMPORT_CUSTOMERS",
        LIST_CUSTOMER_GROUPS: "ACTIONS/CUSTOMERS/LIST_CUSTOMER_GROUPS",
        DELETE_CUSTOMER_GROUP: "ACTIONS/CUSTOMERS/DELETE_CUSTOMER_GROUP",
        CUSTOMER_GROUP_RULE_MASTER: "ACTIONS/CUSTOMERS/CUSTOMER_GROUP_RULE_MASTER",
        ADD_UPDATE_CUSTOMER_GROUP: "ACTIONS/CUSTOMERS/ADD_UPDATE_CUSTOMER_GROUP",
        SEARCH_CUSTOMER_GROUPS: "ACTIONS/CUSTOMERS/SEARCH_CUSTOMER_GROUPS",
        ADD_UPDATE_CUSTOMER_GROUP_CUSTOM: "ACTIONS/CUSTOMERS/ADD_UPDATE_CUSTOMER_GROUP_CUSTOM",
        GET_CUSTOMER_PROMOTIONS: "ACTIONS/CUSTOMERS/GET_CUSTOMER_PROMOTIONS",
        SET_CUSTOMER_FILTERS: "ACTIONS/CUSTOMERS/SET_CUSTOMER_FILTERS",
        CLEAR_CUSTOMER_FILTERS: "ACTIONS/CUSTOMERS/CLEAR_CUSTOMER_FILTERS",
    },
    ORDERS: {
        SEARCH_ORDERS: "ACTIONS/ORDERS/SEARCH_ORDERS",
        SET_ORDER_FILTERS: "ACTIONS/ORDERS/SET_ORDER_FILTERS",
        CLEAR_ORDER_FILTERS: "ACTIONS/ORDERS/CLEAR_ORDER_FILTERS",
    },
    INVENTORY: {
        STOCK_TAKE_LIST: "ACTIONS/INVENTORY/STOCK_TAKE_LIST",
        STOCK_TRANSFER_SEARCH: "ACTIONS/INVENTORY/STOCK_TRANSFER_SEARCH",
        STOCK_TRANSFER_DELETE: "ACTIONS/INVENTORY/STOCK_TRANSFER_DELETE",
        SENT_TO_REPAIR_SEARCH: "ACTIONS/INVENTORY/SENT_TO_REPAIR_SEARCH",
        PENDING_RESTOCK_SEARCH: "ACTIONS/INVENTORY/PENDING_RESTOCK_SEARCH",
        PENDING_RESTOCK_INSERT_UPDATE: "ACTIONS/INVENTORY/PENDING_RESTOCK_INSERT_UPDATE",
        VENDOR_SEARCH: "ACTIONS/INVENTORY/VENDOR_SEARCH",
        VENDOR_STOCK_RETURN_DELETE: "ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_DELETE",
        VENDOR_STOCK_RETURN_STATUS_CHANGE: "ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_STATUS_CHANGE",
        VENDOR_STOCK_RETURN_DETAILS: "ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_DETAILS",
        VENDOR_STOCK_RETURN_INSERT_UPDATE: "ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_INSERT_UPDATE",
        INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER:
            "ACTIONS/INVENTORY/INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER",
        STOCK_TRANSFER_DETAILS: "ACTIONS/INVENTORY/STOCK_TRANSFER_DETAILS",
        PURCHASE_ORDER_SEARCH: "ACTIONS/INVENTORY/PURCHASE_ORDER_SEARCH",
        PURCHASE_ORDER_DETAILS: "ACTIONS/INVENTORY/PURCHASE_ORDER_DETAILS",
        RECEIVE_ORDER_INSERT_UPDATE: "ACTIONS/INVENTORY/RECEIVE_ORDER_INSERT_UPDATE",
        RECEIVE_ORDER_DELETE: "ACTIONS/INVENTORY/RECEIVE_ORDER_DELETE",
        SET_RETURN_ORDER_DATA: "ACTIONS/INVENTORY/SET_RETURN_ORDER_DATA",
    },
    USER_MANAGEMENT: {
        //employee types
        GET_EMPLOYEE_TYPES: "ACTIONS/USER_MANAGEMENT/GET_EMPLOYEE_TYPES",
        UPDATE_EMPLOYEE_TYPES: "ACTIONS/USER_MANAGEMENT/UPDATE_EMPLOYEE_TYPES",
        DELETE_EMPLOYEE_TYPES: "ACTIONS/USER_MANAGEMENT/DELETE_EMPLOYEE_TYPES",

        //pay types
        GET_PAY_TYPES: "ACTIONS/USER_MANAGEMENT/GET_PAY_TYPES",
        UPDATE_PAY_TYPES: "ACTIONS/USER_MANAGEMENT/UPDATE_PAY_TYPES",
        DELETE_PAY_TYPES: "ACTIONS/USER_MANAGEMENT/DELETE_PAY_TYPES",

        //users
        SEARCH_USERS: "ACTIONS/USER_MANAGEMENT/SEARCH_USERS",
        INSERT_UPDATE_USER: "ACTIONS/USER_MANAGEMENT/INSERT_UPDATE_USER",
        DELETE_USER: "ACTIONS/USER_MANAGEMENT/DELETE_USER",
        GET_USER_DETAILS: "ACTIONS/USER_MANAGEMENT/GET_USER_DETAILS",
        SEARCH_USER_SCHEDULE: "ACTIONS/USER_MANAGEMENT/SEARCH_USER_SCHEDULE",

        //roles list
        ROLE_LIST: "ACTIONS/USER_MANAGEMENT/ROLE_LIST",
    },
    GIFT_CARDS: {
        CATEGORY_INSERT_UPDATE: "ACTIONS/GIFT_CARDS/CATEGORY_INSERT_UPDATE",
        CATEGORY_DETAILS_BY_ID: "ACTIONS/GIFT_CARDS/CATEGORY_DETAILS_BY_ID",
        CATEGORY_SEARCH: "ACTIONS/GIFT_CARDS/CATEGORY_SEARCH",
        CATEGORY_LIST: "ACTIONS/GIFT_CARDS/CATEGORY_LIST",
        CONFIGURATION_INSERT_UPDATE: "ACTIONS/GIFT_CARDS/CONFIGURATION_INSERT_UPDATE",
        CONFIGURATION_SEARCH: "ACTIONS/GIFT_CARDS/CONFIGURATION_SEARCH",
        DETAILS_BY_ID: "ACTIONS/GIFT_CARDS/DETAILS_BY_ID",
        PHYSICAL_GIFT_CARD_SEARCH: "ACTIONS/GIFT_CARDS/PHYSICAL_GIFT_CARD_SEARCH",
        HISTORY_SEARCH: "ACTIONS/GIFT_CARDS/HISTORY_SEARCH",
        GENERAL_GIFT_CARD_SEARCH: "ACTIONS/GIFT_CARDS/GENERAL_GIFT_CARD_SEARCH",
    },
    //orders and fulfillment
    ORDERS_AND_FULFILLMENT: {
        GET_SEARCH_ORDERS: "ACTIONS/ORDERS_AND_FULFILLMENT/GET_SEARCH_ORDERS",
        GET_ORDER_DETAILS: "ACTIONS/ORDERS_AND_FULFILLMENT/GET_ORDER_DETAILS",
        GET_RETURN_ORDER_DETAILS: "ACTIONS/ORDERS_AND_FULFILLMENT/GET_RETURN_ORDER_DETAILS",
    },
    SETTINGS_PAYMENT_TYPE: {
        MASTER_GET: "ACTIONS/SETTINGS_PAYMENT_TYPE/MASTER_GET",
        GET: "ACTIONS/SETTINGS_PAYMENT_TYPE/GET",
        INSERT_UPDATE: "ACTIONS/SETTINGS_PAYMENT_TYPE/INSERT_UPDATE",
        DETAILS_BY_ID: "ACTIONS/SETTINGS_PAYMENT_TYPE/DETAILS_BY_ID",
        DELETE: "ACTIONS/SETTINGS_PAYMENT_TYPE/DELETE",
        STATUS_CHANGE: "ACTIONS/SETTINGS_PAYMENT_TYPE/STATUS_CHANGE",
    },
    AGREEMENT_POLICIES: {
        GET_AGREEMENT_POLICIES: "ACTIONS/AGREEMENT_POLICIES/GET_AGREEMENT_POLICIES",
        DELETE_AGREEMENT_POLICY: "ACTIONS/AGREEMENT_POLICIES/DELETE_AGREEMENT_POLICY",
        INSERT_UPDATE_POLICY: "ACTIONS/AGREEMENT_POLICIES/INSERT_UPDATE_POLICY",
        GET_POLICY_BY_ID: "ACTIONS/AGREEMENT_POLICIES/GET_POLICY_BY_ID",
    },

    // Marketing Automation
    MARKETING_CAMPAIGN: {
        SEARCH: "ACTIONS/MARKETING_CAMPAIGN/SEARCH",
        INSERT_UPDATE: "ACTIONS/MARKETING_CAMPAIGN/INSERT_UPDATE",
        DELETE: "ACTIONS/MARKETING_CAMPAIGN/DELETE",
        DETAILS: "ACTIONS/MARKETING_CAMPAIGN/DETAILS",
        DELIVERIES: "ACTIONS/MARKETING_CAMPAIGN/DELIVERIES",
    },
    MARKETING_AUDIENCE_LIST: {
        SEARCH: "ACTIONS/MARKETING_AUDIENCE_LIST/SEARCH",
        INSERT_UPDATE: "ACTIONS/MARKETING_AUDIENCE_LIST/INSERT_UPDATE",
        DELETE: "ACTIONS/MARKETING_AUDIENCE_LIST/DELETE",
        DETAILS: "ACTIONS/MARKETING_AUDIENCE_LIST/DETAILS",
        BULK_UPSERT_MEMBERS: "ACTIONS/MARKETING_AUDIENCE_LIST/BULK_UPSERT_MEMBERS",
        ADD_FROM_GROUPS: "ACTIONS/MARKETING_AUDIENCE_LIST/ADD_FROM_GROUPS",
    },
    MARKETING: {
        MASTER_TAGS: "ACTIONS/MARKETING/MASTER_TAGS",
        VALIDATE_TAGS: "ACTIONS/MARKETING/VALIDATE_TAGS",
        PREVIEW_CONTENT: "ACTIONS/MARKETING/PREVIEW_CONTENT",
        GET_SETTINGS: "ACTIONS/MARKETING/GET_SETTINGS",
        SAVE_EMAIL_SETTINGS: "ACTIONS/MARKETING/SAVE_EMAIL_SETTINGS",
        SAVE_SMS_SETTINGS: "ACTIONS/MARKETING/SAVE_SMS_SETTINGS",
    },
    DEPOSITS: {
        GET: "ACTIONS/DEPOSITS/GET",
        ADD: "ACTIONS/DEPOSITS/ADD",
        UPDATE: "ACTIONS/DEPOSITS/UPDATE",
        DELETE: "ACTIONS/DEPOSITS/DELETE",
    },
    QUICKBOOKS: {
        SETUP_STATUS: "ACTIONS/QUICKBOOKS/SETUP_STATUS",
        SAVE_SETUP: "ACTIONS/QUICKBOOKS/SAVE_SETUP",
        CONNECT: "ACTIONS/QUICKBOOKS/CONNECT",
        DISCONNECT: "ACTIONS/QUICKBOOKS/DISCONNECT",
        DELETE_SETUP: "ACTIONS/QUICKBOOKS/DELETE_SETUP",
        MANUAL_SYNC_STATUS: "ACTIONS/QUICKBOOKS/MANUAL_SYNC_STATUS",
        MANUAL_SYNC_TRIGGER: "ACTIONS/QUICKBOOKS/MANUAL_SYNC_TRIGGER",
        MANUAL_SYNC_LOG: "ACTIONS/QUICKBOOKS/MANUAL_SYNC_LOG",
        MANUAL_SYNC_RETRY: "ACTIONS/QUICKBOOKS/MANUAL_SYNC_RETRY",
        OUTBOX_STATUS: "ACTIONS/QUICKBOOKS/OUTBOX_STATUS",
        OUTBOX_LOG: "ACTIONS/QUICKBOOKS/OUTBOX_LOG",
        OUTBOX_RETRY: "ACTIONS/QUICKBOOKS/OUTBOX_RETRY",
        OUTBOX_RETRY_ALL: "ACTIONS/QUICKBOOKS/OUTBOX_RETRY_ALL",
    },
};

//#region SAGA_ACTIONs
export const SAGA_ACTIONS = {
    USER: {
        LOGIN: "SAGA_ACTIONS/USER/LOGIN",
        LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "SAGA_ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
        REGISTER: "SAGA_ACTIONS/USER/REGISTER",
        GET_DESIGNS: "SAGA_ACTIONS/USER/GET_DESIGNS",
        SAVE_DESIGN: "SAGA_ACTIONS/USER/SAVE_DESIGN",
        UPDATE_DESIGN: "SAGA_ACTIONS/USER/UPDATE_DESIGN",

        IMAGE_LIST: "SAGA_ACTIONS/USER/IMAGE_LIST",
        IMAGE_UPLOAD: "SAGA_ACTIONS/USER/IMAGE_UPLOAD",
        IMAGE_DELETE: "SAGA_ACTIONS/USER/IMAGE_DELETE",
        GET_MENUS: "SAGA_ACTIONS/USER/GET_MENUS",
        GET_USER_ACTIVITY: "SAGA_ACTIONS/USER/GET_USER_ACTIVITY",
        LAST_PUNCH_STATUS: "SAGA_ACTIONS/USER/LAST_PUNCH_STATUS",
        CLOCK_IN: "SAGA_ACTIONS/USER/CLOCK_IN",
    },
    COMMON: {
        GET_CITY: "SAGA_ACTIONS/COMMON/GET_CITY",
        GET_STATE: "SAGA_ACTIONS/COMMON/GET_STATE",
        GET_COUNTY: "SAGA_ACTIONS/COMMON/GET_COUNTY",
        GET_COUNTRY: "SAGA_ACTIONS/COMMON/GET_COUNTRY",
        LOOKUP_VALUES: "SAGA_ACTIONS/COMMON/LOOKUP_VALUES",
        LOCATION_SEARCH: "SAGA_ACTIONS/CATEGORIES/LOCATION_SEARCH",
        GET_CURRENCY: "SAGA_ACTIONS/COMMON/GET_CURRENCY",
        GET_TIMEZONES: "SAGA_ACTIONS/COMMON/GET_TIMEZONES",
    },
    CATEGORIES: {
        GET_CATEGORIES_LIST: "SAGA_ACTIONS/CATEGORIES/GET_CATEGORIES_LIST",
        ADD_UPDATE_CATEGORY: "SAGA_ACTIONS/CATEGORIES/ADD_UPDATE_CATEGORY",
        DELETE_CATEGORY: "SAGA_ACTIONS/CATEGORIES/DELETE_CATEGORY",
        SEARCH_CATEGORY: "SAGA_ACTIONS/CATEGORIES/SEARCH_CATEGORY",
        CATEGORY_DETAILS: "SAGA_ACTIONS/CATEGORIES/CATEGORY_DETAILS",
        REARRANGE_CATEGORY: "SAGA_ACTIONS/CATEGORIES/REARRANGE_CATEGORY",
    },
    UNITS: {
        SEARCH_UNIT: "SAGA_ACTIONS/UNITS/SEARCH_UNIT",
        ADD_UPDATE_UNIT: "SAGA_ACTIONS/UNITS/ADD_UPDATE_UNIT",
        DELETE_UNIT: "SAGA_ACTIONS/UNITS/DELETE_UNIT",
        UNIT_DETAILS: "SAGA_ACTIONS/UNITS/UNIT_DETAILS",
    },
    BRANDS: {
        SEARCH_BRAND: "SAGA_ACTIONS/BRANDS/SEARCH_BRAND",
        ADD_UPDATE_BRAND: "SAGA_ACTIONS/BRANDS/ADD_UPDATE_BRAND",
        DELETE_BRAND: "SAGA_ACTIONS/BRANDS/DELETE_BRAND",
        BRAND_DETAILS: "SAGA_ACTIONS/BRANDS/BRAND_DETAILS",
    },
    ATTRIBUTES: {
        SEARCH_ATTRIBUTE: "SAGA_ACTIONS/ATTRIBUTES/SEARCH_ATTRIBUTE",
        ADD_UPDATE_ATTRIBUTE: "SAGA_ACTIONS/ATTRIBUTES/ADD_UPDATE_ATTRIBUTE",
        DELETE_ATTRIBUTE: "SAGA_ACTIONS/ATTRIBUTES/DELETE_ATTRIBUTE",
        ATTRIBUTE_DETAILS: "SAGA_ACTIONS/ATTRIBUTES/ATTRIBUTE_DETAILS",
    },
    PRODUCTS: {
        SEARCH_PRODUCT: "SAGA_ACTIONS/PRODUCTS/SEARCH_PRODUCT",
        ADD_UPDATE_PRODUCT: "SAGA_ACTIONS/PRODUCTS/ADD_UPDATE_PRODUCT",
        DELETE_PRODUCT: "SAGA_ACTIONS/PRODUCTS/DELETE_PRODUCT",
        GENERATE_SKU: "SAGA_ACTIONS/PRODUCTS/GENERATE_SKU",
        UPDATE_INVENTORY: "SAGA_ACTIONS/PRODUCTS/UPDATE_INVENTORY",
        UPDATE_PRICES: "SAGA_ACTIONS/PRODUCTS/UPDATE_PRICES",
        BULK_UPDATE_PRODUCTS: "SAGA_ACTIONS/PRODUCTS/BULK_UPDATE_PRODUCTS",
        STATUS_CHANGE: "SAGA_ACTIONS/PRODUCTS/STATUS_CHANGE",
        NON_TAXABLE_PRODUCT_SEARCH: "SAGA_ACTIONS/PRODUCTS/NON_TAXABLE_PRODUCT_SEARCH",
        ADD_NON_TAXABLE_PRODUCT: "SAGA_ACTIONS/PRODUCTS/ADD_NON_TAXABLE_PRODUCT",
        CHECK_SKU_UNIQUE: "SAGA_ACTIONS/PRODUCTS/CHECK_SKU_UNIQUE",
        REARRANGE_PRODUCTS: "SAGA_ACTIONS/PRODUCTS/REARRANGE_PRODUCTS",
        ADMIN_POPULAR_PRODUCT_SEARCH: "SAGA_ACTIONS/PRODUCTS/ADMIN_POPULAR_PRODUCT_SEARCH",
        REARRANGE_POPULAR_PRODUCTS: "SAGA_ACTIONS/PRODUCTS/REARRANGE_POPULAR_PRODUCTS",
    },
    TAGS: {
        SEARCH_TAG: "SAGA_ACTIONS/TAGS/SEARCH_TAG",
        ADD_UPDATE_TAG: "SAGA_ACTIONS/TAGS/ADD_UPDATE_TAG",
        DELETE_TAG: "SAGA_ACTIONS/TAGS/DELETE_TAG",
        TAG_DETAILS: "SAGA_ACTIONS/TAGS/TAG_DETAILS",
    },
    VENDORS: {
        SEARCH_VENDOR: "SAGA_ACTIONS/VENDORS/SEARCH_VENDOR",
        ADD_UPDATE_VENDOR: "SAGA_ACTIONS/VENDORS/ADD_UPDATE_VENDOR",
        DELETE_VENDOR: "SAGA_ACTIONS/VENDORS/DELETE_VENDOR",
        VENDOR_DETAILS: "SAGA_ACTIONS/VENDORS/VENDOR_DETAILS",
        CHECK_SKU_UNIQUE: "SAGA_ACTIONS/VENDORS/CHECK_SKU_UNIQUE",
    },
    CUSTOMERS: {
        LIST_CUSTOMER: "SAGA_ACTIONS/CUSTOMERS/LIST_CUSTOMER",
        SEARCH_CUSTOMER: "SAGA_ACTIONS/CUSTOMERS/SEARCH_CUSTOMER",
        CUSTOMER_DETAILS: "SAGA_ACTIONS/CUSTOMERS/CUSTOMER_DETAILS",
        ADD_UPDATE_CUSTOMER: "SAGA_ACTIONS/CUSTOMERS/ADD_UPDATE_CUSTOMER",
        DELETE_CUSTOMER: "SAGA_ACTIONS/CUSTOMERS/DELETE_CUSTOMER",
        IMPORT_CUSTOMERS: "SAGA_ACTIONS/CUSTOMERS/IMPORT_CUSTOMERS",
        LIST_CUSTOMER_GROUPS: "SAGA_ACTIONS/CUSTOMERS/LIST_CUSTOMER_GROUPS",
        DELETE_CUSTOMER_GROUP: "SAGA_ACTIONS/CUSTOMERS/DELETE_CUSTOMER_GROUP",
        ADD_UPDATE_CUSTOMER_GROUP: "SAGA_ACTIONS/CUSTOMERS/ADD_UPDATE_CUSTOMER_GROUP",
        CUSTOMER_GROUP_RULE_MASTER: "SAGA_ACTIONS/CUSTOMERS/CUSTOMER_GROUP_RULE_MASTER",

        SEARCH_CUSTOMER_GROUPS: "SAGA_ACTIONS/CUSTOMERS/SEARCH_CUSTOMER_GROUPS",
        ADD_UPDATE_CUSTOMER_GROUP_CUSTOM: "SAGA_ACTIONS/CUSTOMERS/ADD_UPDATE_CUSTOMER_GROUP_CUSTOM",
        GET_CUSTOMER_PROMOTIONS: "SAGA_ACTIONS/CUSTOMERS/GET_CUSTOMER_PROMOTIONS",
    },
    STORAGE: {
        UPLOAD_IMAGE: "SAGA_ACTIONS/STORAGE/UPLOAD_IMAGE",
    },
    DISCOUNTS: {
        SEARCH_DISCOUNT: "SAGA_ACTIONS/DISCOUNTS/SEARCH_DISCOUNT",
        ADD_UPDATE_DISCOUNT: "SAGA_ACTIONS/DISCOUNTS/ADD_UPDATE_DISCOUNT",
        DELETE_DISCOUNT: "SAGA_ACTIONS/DISCOUNTS/DELETE_DISCOUNT",
    },
    BUSINESS: {
        STORE_LOCATIONS_LIST: "SAGA_ACTIONS/BUSINESS/STORE_LOCATIONS_LIST",
        STORE_LOCATIONS_INSERT_UPDATE: "SAGA_ACTIONS/BUSINESS/STORE_LOCATIONS_INSERT_UPDATE",
    },
    INVENTORY: {
        STOCK_TAKE_LIST: "SAGA_ACTIONS/INVENTORY/STOCK_TAKE_LIST",
        STOCK_TAKE_DELETE: "SAGA_ACTIONS/INVENTORY/STOCK_TAKE_DELETE",
        STOCK_TRANSFER_SEARCH: "SAGA_ACTIONS/INVENTORY/STOCK_TRANSFER_SEARCH",
        STOCK_TRANSFER_DELETE: "SAGA_ACTIONS/INVENTORY/STOCK_TRANSFER_DELETE",
        SENT_TO_REPAIR_SEARCH: "SAGA_ACTIONS/INVENTORY/SENT_TO_REPAIR_SEARCH",
        PENDING_RESTOCK_SEARCH: "SAGA_ACTIONS/INVENTORY/PENDING_RESTOCK_SEARCH",
        PENDING_RESTOCK_INSERT_UPDATE: "SAGA_ACTIONS/INVENTORY/PENDING_RESTOCK_INSERT_UPDATE",
        VENDOR_SEARCH: "SAGA_ACTIONS/INVENTORY/VENDOR_SEARCH",
        SCHEDULE_INSERT_UPDATE: "SAGA_ACTIONS/INVENTORY/SCHEDULE_INSERT_UPDATE",
        STOCK_TAKE_DETAILS: "SAGA_ACTIONS/INVENTORY/STOCK_TAKE_DETAILS",
        VENDOR_STOCK_RETURN_SEARCH: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_SEARCH",
        VENDOR_STOCK_RETURN_DELETE: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_DELETE",
        VENDOR_STOCK_RETURN_DETAILS: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_DETAILS",
        VENDOR_STOCK_RETURN_INSERT_UPDATE: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_INSERT_UPDATE",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_SEARCH: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_RECEIVE_ORDER_SEARCH",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_INSERT_UPDATE: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_RECEIVE_ORDER_INSERT_UPDATE",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_DETAILS: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_RECEIVE_ORDER_DETAILS",
        VENDOR_STOCK_RETURN_RECEIVE_ORDER_DELETE: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_RECEIVE_ORDER_DELETE",
        VENDOR_STOCK_RETURN_STATUS_CHANGE: "SAGA_ACTIONS/INVENTORY/VENDOR_STOCK_RETURN_STATUS_CHANGE",
        INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER:
            "SAGA_ACTIONS/INVENTORY/INSERT_UPDATE_STOCK_TRANSFER_WITHIN_LOCATION_TRANSFER",
        STOCK_TRANSFER_DETAILS: "SAGA_ACTIONS/INVENTORY/STOCK_TRANSFER_DETAILS",
        PREFERRED_VENDORS: "SAGA_ACTIONS/INVENTORY/PREFERRED_VENDORS",
        AUTO_PO_UNASSIGNED_PRODUCTS: "SAGA_ACTIONS/INVENTORY/AUTO_PO_UNASSIGNED_PRODUCTS",
        AUTO_PO_VENDOR_PRODUCTS: "SAGA_ACTIONS/INVENTORY/AUTO_PO_VENDOR_PRODUCTS",
        MANUAL_PO_UNASSIGNED_PRODUCTS: "SAGA_ACTIONS/INVENTORY/MANUAL_PO_UNASSIGNED_PRODUCTS",
        MANUAL_PO_VENDOR_PRODUCTS: "SAGA_ACTIONS/INVENTORY/MANUAL_PO_VENDOR_PRODUCTS",
        INSERT_UPDATE_PO: "SAGA_ACTIONS/INVENTORY/INSERT_UPDATE_PO",
        CHANGE_VENDOR: "SAGA_ACTIONS/INVENTORY/CHANGE_VENDOR",
        PURCHASE_ORDER_SEARCH: "SAGA_ACTIONS/INVENTORY/PURCHASE_ORDER_SEARCH",
        PURCHASE_ORDER_DETAILS: "SAGA_ACTIONS/INVENTORY/PURCHASE_ORDER_DETAILS",
        PURCHASE_ORDER_DELETE: "SAGA_ACTIONS/INVENTORY/PURCHASE_ORDER_DELETE",
        PURCHASE_ORDER_STATUS_CHANGE: "SAGA_ACTIONS/INVENTORY/PURCHASE_ORDER_STATUS_CHANGE",
        RECEIVE_ORDER_SEARCH: "SAGA_ACTIONS/INVENTORY/RECEIVE_ORDER_SEARCH",
        RECEIVE_ORDER_INSERT_UPDATE: "SAGA_ACTIONS/INVENTORY/RECEIVE_ORDER_INSERT_UPDATE",
        RECEIVE_ORDER_DETAILS: "SAGA_ACTIONS/INVENTORY/RECEIVE_ORDER_DETAILS",
        RECEIVE_ORDER_DELETE: "SAGA_ACTIONS/INVENTORY/RECEIVE_ORDER_DELETE",
        SEND_EMAIL_TO_VENDOR: "SAGA_ACTIONS/INVENTORY/SEND_EMAIL_TO_VENDOR",
        GET_INBOUND_ORDER_QTY: "SAGA_ACTIONS/INVENTORY/GET_INBOUND_ORDER_QTY",
        STOCK_COUNT_DETAILS: "SAGA_ACTIONS/INVENTORY/STOCK_COUNT_DETAILS",
        START_STOCK_COUNT: "SAGA_ACTIONS/INVENTORY/START_STOCK_COUNT",
        COMPLETE_STOCK_COUNT: "SAGA_ACTIONS/INVENTORY/COMPLETE_STOCK_COUNT",
        CHANGE_STOCK_COUNT_STATUS: "SAGA_ACTIONS/INVENTORY/CHANGE_STOCK_COUNT_STATUS",
        INSERT_PRODUCT: "SAGA_ACTIONS/INVENTORY/INSERT_PRODUCT",
        RECEIVE_STOCK_TRANSFER: "SAGA_ACTIONS/INVENTORY/RECEIVE_STOCK_TRANSFER",
        PRODUCT_INVENTORY_INSIGHT: "SAGA_ACTIONS/INVENTORY/PRODUCT_INVENTORY_INSIGHT",
    },
    SETTINGS: {
        STORE_CREDIT_GET: "SAGA_ACTIONS/INVENTORY/STORE_CREDIT_GET",
        STORE_CREDIT_INSERT_UPDATE: "SAGA_ACTIONS/INVENTORY/STORE_CREDIT_INSERT_UPDATE",
    },
    TAX: {
        REFRESH_COMPANY_RATES: "SAGA_ACTIONS/TAX/REFRESH_COMPANY_RATES",
        GET_RATE: "SAGA_ACTIONS/TAX/GET_RATE",
        RATE_BULK: "SAGA_ACTIONS/TAX/RATE_BULK",
        ADDITIONAL_TAX_LIST: "SAGA_ACTIONS/TAX/ADDITIONAL_TAX_LIST",
        ADDITIONAL_TAX_INSERT_UPDATE: "SAGA_ACTIONS/TAX/ADDITIONAL_TAX_INSERT_UPDATE",
        ADDITIONAL_TAX_DETAILS: "SAGA_ACTIONS/TAX/ADDITIONAL_TAX_DETAILS",
        ADDITIONAL_TAX_DELETE: "SAGA_ACTIONS/TAX/ADDITIONAL_TAX_DELETE",
    },
    DONATION: {
        GET: "SAGA_ACTIONS/DONATION/GET",
        INSERT_UPDATE: "SAGA_ACTIONS/DONATION/INSERT_UPDATE",
    },
    CASH_DISCOUNT: {
        GET: "SAGA_ACTIONS/CASH_DISCOUNT/GET",
        INSERT_UPDATE: "SAGA_ACTIONS/CASH_DISCOUNT/INSERT_UPDATE",
    },
    TIP: {
        GET: "SAGA_ACTIONS/TIP/GET",
        INSERT_UPDATE: "SAGA_ACTIONS/TIP/INSERT_UPDATE",
    },
    CONSENT: {
        GET_CONTENT: "SAGA_ACTIONS/CONSENT/GET_CONTENT",
        GET_MERCHANT: "SAGA_ACTIONS/CONSENT/GET_MERCHANT",
        ACCEPT_MERCHANT: "SAGA_ACTIONS/CONSENT/ACCEPT_MERCHANT",
        GET_SMS_PREFERENCE: "SAGA_ACTIONS/CONSENT/GET_SMS_PREFERENCE",
        SAVE_SMS_PREFERENCE: "SAGA_ACTIONS/CONSENT/SAVE_SMS_PREFERENCE",
    },
    SETTINGS_LANGUAGE: {
        GET: "SAGA_ACTIONS/SETTINGS_LANGUAGE/GET",
        SAVE: "SAGA_ACTIONS/SETTINGS_LANGUAGE/SAVE",
    },
    SETTINGS_MANUAL_PRODUCT_TAXABLE: {
        GET: "SAGA_ACTIONS/SETTINGS_MANUAL_PRODUCT_TAXABLE/GET",
        SAVE: "SAGA_ACTIONS/SETTINGS_MANUAL_PRODUCT_TAXABLE/SAVE",
    },
    ADDITIONAL_TAX: {
        GET_APPLICABLE: "SAGA_ACTIONS/ADDITIONAL_TAX/GET_APPLICABLE",
        GET_PRODUCT_LOCATION_TAXES: "SAGA_ACTIONS/ADDITIONAL_TAX/GET_PRODUCT_LOCATION_TAXES",
        SAVE_PRODUCT_LOCATION_TAXES: "SAGA_ACTIONS/ADDITIONAL_TAX/SAVE_PRODUCT_LOCATION_TAXES",
    },
    LOYALTY_REWARD: {
        LIST: "SAGA_ACTIONS/LOYALTY_REWARD/LIST",
        DETAILS: "SAGA_ACTIONS/LOYALTY_REWARD/DETAILS",
        INSERT_UPDATE: "SAGA_ACTIONS/LOYALTY_REWARD/INSERT_UPDATE",
        DELETE: "SAGA_ACTIONS/LOYALTY_REWARD/DELETE",
    },
    LOYALTY: {
        GET_LOYALTY: "SAGA_ACTIONS/LOYALTY/GET_LOYALTY",
        LOYALTY_DETAILS: "SAGA_ACTIONS/LOYALTY/LOYALTY_DETAILS",
        ADD_UPDATE_LOYALTY: "SAGA_ACTIONS/LOYALTY/ADD_UPDATE_LOYALTY",
        DELETE_LOYALTY: "SAGA_ACTIONS/LOYALTY/DELETE_LOYALTY",
        ACTIVITY_SEARCH: "SAGA_ACTIONS/LOYALTY/ACTIVITY_SEARCH",
        GET_AVG_CUSTOMER_SPEND: "SAGA_ACTIONS/LOYALTY/GET_AVG_CUSTOMER_SPEND",
        GET_LOYALTY_SALES: "SAGA_ACTIONS/LOYALTY/GET_LOYALTY_SALES",
        GET_TOP_CUSTOMERS: "SAGA_ACTIONS/LOYALTY/GET_TOP_CUSTOMERS",
        GET_CUSTOMER_VISITS: "SAGA_ACTIONS/LOYALTY/GET_CUSTOMER_VISITS",
        GET_REWARDS_DATA: "SAGA_ACTIONS/LOYALTY/GET_REWARDS_DATA",
    },
    SETTINGS_RETURN: {
        SETTING_RETURN_INSERT_UPDATE: "SAGA_ACTIONS/SETTINGS_RETURN/SETTING_RETURN_INSERT_UPDATE",
        GET_SETTING_RETURN_POLICY: "SAGA_ACTIONS/SETTINGS_RETURN/GET_SETTING_RETURN_POLICY",
    },
    NOTIFICATIONS: {
        GET_NOTIFICATION_REMINDERS: "SAGA_ACTIONS/NOTIFICATIONS/GET_NOTIFICATION_REMINDERS",
        INSERT_UPDATE_NOTIFICATION_REMINDERS: "SAGA_ACTIONS/NOTIFICATIONS/INSERT_UPDATE_NOTIFICATION_REMINDERS",
    },
    USER_MANAGEMENT: {
        //employee types
        GET_EMPLOYEE_TYPES: "SAGA_ACTIONS/USER_MANAGEMENT/GET_EMPLOYEE_TYPES",
        UPDATE_EMPLOYEE_TYPES: "SAGA_ACTIONS/USER_MANAGEMENT/UPDATE_EMPLOYEE_TYPES",
        DELETE_EMPLOYEE_TYPES: "SAGA_ACTIONS/USER_MANAGEMENT/DELETE_EMPLOYEE_TYPES",

        //pay types
        GET_PAY_TYPES: "SAGA_ACTIONS/USER_MANAGEMENT/GET_PAY_TYPES",
        UPDATE_PAY_TYPES: "SAGA_ACTIONS/USER_MANAGEMENT/UPDATE_PAY_TYPES",
        DELETE_PAY_TYPES: "SAGA_ACTIONS/USER_MANAGEMENT/DELETE_PAY_TYPES",

        //users
        SEARCH_USERS: "SAGA_ACTIONS/USER_MANAGEMENT/SEARCH_USERS",
        INSERT_UPDATE_USER: "SAGA_ACTIONS/USER_MANAGEMENT/INSERT_UPDATE_USER",
        DELETE_USER: "SAGA_ACTIONS/USER_MANAGEMENT/DELETE_USER",
        GET_USER_DETAILS: "SAGA_ACTIONS/USER_MANAGEMENT/GET_USER_DETAILS",
        GET_USER_SCHEDULE: "SAGA_ACTIONS/USER_MANAGEMENT/GET_USER_SCHEDULE",
        SEARCH_USER_SCHEDULE: "SAGA_ACTIONS/USER_MANAGEMENT/SEARCH_USER_SCHEDULE",
        INSERT_UPDATE_USER_SCHEDULE: "SAGA_ACTIONS/USER_MANAGEMENT/INSERT_UPDATE_USER_SCHEDULE",
        GET_USER_SCHEDULE_BY_ID: "SAGA_ACTIONS/USER_MANAGEMENT/GET_USER_SCHEDULE_BY_ID",
        VALIDATE_MPIN: "SAGA_ACTIONS/USER_MANAGEMENT/VALIDATE_MPIN",

        //role permissions
        GET_ROLE_PERMISSION: "SAGA_ACTIONS/USER_MANAGEMENT/GET_ROLE_PERMISSION",
        ROLE_LIST: "SAGA_ACTIONS/USER_MANAGEMENT/ROLE_LIST",
        INSERT_UPDATE_ROLE_PERMISSION: "SAGA_ACTIONS/USER_MANAGEMENT/INSERT_UPDATE_ROLE_PERMISSION",
        DELETE_ROLE_PERMISSION: "SAGA_ACTIONS/USER_MANAGEMENT/DELETE_ROLE_PERMISSION",
    },
    GIFT_CARDS: {
        CATEGORY_INSERT_UPDATE: "SAGA_ACTIONS/GIFT_CARDS/CATEGORY_INSERT_UPDATE",
        CATEGORY_DETAILS_BY_ID: "SAGA_ACTIONS/GIFT_CARDS/CATEGORY_DETAILS_BY_ID",
        CATEGORY_SEARCH: "SAGA_ACTIONS/GIFT_CARDS/CATEGORY_SEARCH",
        CATEGORY_LIST: "SAGA_ACTIONS/GIFT_CARDS/CATEGORY_LIST",
        CONFIGURATION_INSERT_UPDATE: "SAGA_ACTIONS/GIFT_CARDS/CONFIGURATION_INSERT_UPDATE",
        CONFIGURATION_SEARCH: "SAGA_ACTIONS/GIFT_CARDS/CONFIGURATION_SEARCH",
        DETAILS_BY_ID: "SAGA_ACTIONS/GIFT_CARDS/DETAILS_BY_ID",
        PHYSICAL_GIFT_CARD_SEARCH: "SAGA_ACTIONS/GIFT_CARDS/PHYSICAL_GIFT_CARD_SEARCH",
        HISTORY_SEARCH: "SAGA_ACTIONS/GIFT_CARDS/HISTORY_SEARCH",
        GENERAL_GIFT_CARD_SEARCH: "SAGA_ACTIONS/GIFT_CARDS/GENERAL_GIFT_CARD_SEARCH",
    },

    //orders and fulfillments
    ORDERS_AND_FULFILLMENT: {
        GET_SEARCH_ORDERS: "SAGA_ACTIONS/ORDERS_AND_FULFILLMENT/GET_SEARCH_ORDERS",
        GET_ORDER_DETAILS: "SAGA_ACTIONS/ORDERS_AND_FULFILLMENT/GET_ORDER_DETAILS",
        GET_RETURN_ORDER_DETAILS: "SAGA_ACTIONS/ORDERS_AND_FULFILLMENT/GET_RETURN_ORDER_DETAILS",
    },
    SETTINGS_PAYMENT_TYPE: {
        MASTER_GET: "SAGA_ACTIONS/SETTINGS_PAYMENT_TYPE/MASTER_GET",
        GET: "SAGA_ACTIONS/SETTINGS_PAYMENT_TYPE/GET",
        INSERT_UPDATE: "SAGA_ACTIONS/SETTINGS_PAYMENT_TYPE/INSERT_UPDATE",
        DETAILS_BY_ID: "SAGA_ACTIONS/SETTINGS_PAYMENT_TYPE/DETAILS_BY_ID",
        DELETE: "SAGA_ACTIONS/SETTINGS_PAYMENT_TYPE/DELETE",
        STATUS_CHANGE: "SAGA_ACTIONS/SETTINGS_PAYMENT_TYPE/STATUS_CHANGE",
    },
    AGREEMENT_POLICIES: {
        GET_AGREEMENT_POLICIES: "SAGA_ACTIONS/AGREEMENT_POLICIES/GET_AGREEMENT_POLICIES",
        DELETE_AGREEMENT_POLICY: "SAGA_ACTIONS/AGREEMENT_POLICIES/DELETE_AGREEMENT_POLICY",
        INSERT_UPDATE_POLICY: "SAGA_ACTIONS/AGREEMENT_POLICIES/INSERT_UPDATE_POLICY",
        GET_POLICY_BY_ID: "SAGA_ACTIONS/AGREEMENT_POLICIES/GET_POLICY_BY_ID",
    },
    TEMPLATES: {
        GET_MESSAGE_TEMPLATE: "SAGA_ACTIONS/TEMPLATES/GET_MESSAGE_TEMPLATE",
        INSERT_UPDATE_MESSAGE_TEMPLATE: "SAGA_ACTIONS/TEMPLATES/INSERT_UPDATE_MESSAGE_TEMPLATE",
        GET_EMAIL_TEMPLATE: "SAGA_ACTIONS/TEMPLATES/GET_EMAIL_TEMPLATE",
        INSERT_UPDATE_EMAIL_TEMPLATE: "SAGA_ACTIONS/TEMPLATES/INSERT_UPDATE_EMAIL_TEMPLATE",
    },
    COMPANY: {
        GET_COMPANY_DETAILS: "SAGA_ACTIONS/COMPANY/GET_COMPANY_DETAILS",
        UPDATE_COMPANY_DETAILS: "SAGA_ACTIONS/COMPANY/UPDATE_COMPANY_DETAILS",
    },
    RECEIPT_TEMPLATE: {
        INSERT_UPDATE: "SAGA_ACTIONS/RECEIPT_TEMPLATE/INSERT_UPDATE",
        DETAILS_BY_ID: "SAGA_ACTIONS/RECEIPT_TEMPLATE/DETAILS_BY_ID",
    },
    REPORTING: {
        REFUND_REPORT: "SAGA_ACTIONS/REPORTING/REFUND_REPORT",
        SALES_REPORT: "SAGA_ACTIONS/REPORTING/SALES_REPORT",
        TIME_CARDS_REPORT: "SAGA_ACTIONS/REPORTING/TIME_CARDS_REPORT",
        TIP_REPORT: "SAGA_ACTIONS/REPORTING/TIP_REPORT",
        INVENTORY_MOVEMENT_REPORT: "SAGA_ACTIONS/REPORTING/INVENTORY_MOVEMENT_REPORT",
        INVENTORY_STOCK_REPORT: "SAGA_ACTIONS/REPORTING/INVENTORY_STOCK_REPORT",
        TRANSACTION_REPORT: "SAGA_ACTIONS/REPORTING/TRANSACTION_REPORT",
        COMMISSION_REPORT: "SAGA_ACTIONS/REPORTING/COMMISSION_REPORT",
        SALES_BY_LOCATION: "SAGA_ACTIONS/REPORTING/SALES_BY_LOCATION",
        SALES_BY_CATEGORY: "SAGA_ACTIONS/REPORTING/SALES_BY_CATEGORY",
        SALES_BY_PRODUCT_TYPE: "SAGA_ACTIONS/REPORTING/SALES_BY_PRODUCT_TYPE",
        SALES_BY_PRODUCT: "SAGA_ACTIONS/REPORTING/SALES_BY_PRODUCT",
        SALES_BY_VENDOR: "SAGA_ACTIONS/REPORTING/SALES_BY_VENDOR",
        SALES_BY_DISCOUNT: "SAGA_ACTIONS/REPORTING/SALES_BY_DISCOUNT",
        VOID_TRANSACTION: "SAGA_ACTIONS/REPORTING/VOID_TRANSACTION",
        CASTLE_PAY_VOID: "SAGA_ACTIONS/REPORTING/CASTLE_PAY_VOID",
        PO_TERMINALS: "SAGA_ACTIONS/REPORTING/PO_TERMINALS",
        GROSS_PROFIT: "SAGA_ACTIONS/REPORTING/GROSS_PROFIT",
        NET_SALES: "SAGA_ACTIONS/REPORTING/NET_SALES",
        RETURNS: "SAGA_ACTIONS/REPORTING/RETURNS",
        LOYALTY_PROGRAM: "SAGA_ACTIONS/REPORTING/LOYALTY_PROGRAM",
        STORE_CREDIT: "SAGA_ACTIONS/REPORTING/STORE_CREDIT",
        COGS: "SAGA_ACTIONS/REPORTING/COGS",
        TAX: "SAGA_ACTIONS/REPORTING/TAX",
        INVENTORY_SUMMARY: "SAGA_ACTIONS/REPORTING/INVENTORY_SUMMARY",
        SALES_BY_CUSTOMER_GROUP: "SAGA_ACTIONS/REPORTING/SALES_BY_CUSTOMER_GROUP",
        RETURN_BY_VENDOR: "SAGA_ACTIONS/REPORTING/RETURN_BY_VENDOR",
        TOP_SELLING_CATEGORY: "SAGA_ACTIONS/REPORTING/TOP_SELLING_CATEGORY",
        STOCK_ADJUSTMENT: "SAGA_ACTIONS/REPORTING/STOCK_ADJUSTMENT",
        DEPOSIT_REPORT: "SAGA_ACTIONS/REPORTING/DEPOSIT_REPORT",
        CART_DISCARDED_PRODUCT: "SAGA_ACTIONS/REPORTING/CART_DISCARDED_PRODUCT",
        END_OF_DAY_REPORT: "SAGA_ACTIONS/REPORTING/END_OF_DAY_REPORT",
        CASH_REGISTER_CLOSE_REPORT: "SAGA_ACTIONS/REPORTING/CASH_REGISTER_CLOSE_REPORT",
        BATCH_CLOSE_REPORT: "SAGA_ACTIONS/REPORTING/BATCH_CLOSE_REPORT",
        SALES_SUMMARY: "SAGA_ACTIONS/REPORTING/SALES_SUMMARY",
        CASH_DROP_REPORT: "SAGA_ACTIONS/REPORTING/CASH_DROP_REPORT",
    },
    DASHBOARD: {
        GET_TOTAL_REVENUE: "SAGA_ACTIONS/DASHBOARD/GET_TOTAL_REVENUE",
        GET_AVG_SALES_TICKET: "SAGA_ACTIONS/DASHBOARD/GET_AVG_SALES_TICKET",
        GET_EXPENSE_TOTAL: "SAGA_ACTIONS/DASHBOARD/GET_EXPENSE_TOTAL",
        GET_GROSS_MARGIN_PERCENTAGE: "SAGA_ACTIONS/DASHBOARD/GET_GROSS_MARGIN_PERCENTAGE",
        GET_ONLINE_VS_OFFLINE: "SAGA_ACTIONS/DASHBOARD/GET_ONLINE_VS_OFFLINE",
        GET_REPEAT_CUSTOMER_PERCENTAGE: "SAGA_ACTIONS/DASHBOARD/GET_REPEAT_CUSTOMER_PERCENTAGE",
        GET_GROSS_MARGIN_CHART: "SAGA_ACTIONS/DASHBOARD/GET_GROSS_MARGIN_CHART",
        GET_REVENUE_EXPENSE_CHART: "SAGA_ACTIONS/DASHBOARD/GET_REVENUE_EXPENSE_CHART",
        GET_PURCHASE_COST_CHART: "SAGA_ACTIONS/DASHBOARD/GET_PURCHASE_COST_CHART",
        GET_SALES_VOLUME_CHART: "SAGA_ACTIONS/DASHBOARD/GET_SALES_VOLUME_CHART",
        GET_TOP_PRODUCTS: "SAGA_ACTIONS/DASHBOARD/GET_TOP_PRODUCTS",
        GET_TOP_PROMOTIONS: "SAGA_ACTIONS/DASHBOARD/GET_TOP_PROMOTIONS",
        GET_TOP_CATEGORIES: "SAGA_ACTIONS/DASHBOARD/GET_TOP_CATEGORIES",
        GET_TOP_SALES_PERSON: "SAGA_ACTIONS/DASHBOARD/GET_TOP_SALES_PERSON",
        GET_EMPLOYEE_WORK_TIME: "SAGA_ACTIONS/DASHBOARD/GET_EMPLOYEE_WORK_TIME",
        GET_CUSTOMER_COMPARISON: "SAGA_ACTIONS/DASHBOARD/GET_CUSTOMER_COMPARISON",
        GET_AVG_SALES_TICKET_COMPARISON: "SAGA_ACTIONS/DASHBOARD/GET_AVG_SALES_TICKET_COMPARISON",
        GET_REPEAT_CUSTOMER_COMPARISON: "SAGA_ACTIONS/DASHBOARD/GET_REPEAT_CUSTOMER_COMPARISON",
        GET_GROSS_SALES_NET_SALES_CHART: "SAGA_ACTIONS/DASHBOARD/GET_GROSS_SALES_NET_SALES_CHART",
        GET_GROSS_COST_LABOR_COST_CHART: "SAGA_ACTIONS/DASHBOARD/GET_GROSS_COST_LABOR_COST_CHART",
        GET_RETURNS_REFUNDS_TREND: "SAGA_ACTIONS/DASHBOARD/GET_RETURNS_REFUNDS_TREND",
        GET_VOIDS_CANCELLATIONS: "SAGA_ACTIONS/DASHBOARD/GET_VOIDS_CANCELLATIONS",
        GET_TRANSACTION_VOLUME: "SAGA_ACTIONS/DASHBOARD/GET_TRANSACTION_VOLUME",
        GET_SALES_BY_PAYMENT_METHOD: "SAGA_ACTIONS/DASHBOARD/GET_SALES_BY_PAYMENT_METHOD",
        GET_POINTS_ISSUED_BY_LOYALTY_TYPE: "SAGA_ACTIONS/DASHBOARD/GET_POINTS_ISSUED_BY_LOYALTY_TYPE",
        GET_SALES_TREND_BY_HOUR: "SAGA_ACTIONS/DASHBOARD/GET_SALES_TREND_BY_HOUR",
        GET_SALES_BREAKDOWN: "SAGA_ACTIONS/DASHBOARD/GET_SALES_BREAKDOWN",
        GET_POINTS_REDEEMED_BY_LOYALTY_TYPE: "SAGA_ACTIONS/DASHBOARD/GET_POINTS_REDEEMED_BY_LOYALTY_TYPE",
        GET_PARTICIPATION_RATE_BY_LOYALTY_TYPE: "SAGA_ACTIONS/DASHBOARD/GET_PARTICIPATION_RATE_BY_LOYALTY_TYPE",
        GET_GROSS_SALES: "SAGA_ACTIONS/DASHBOARD/GET_GROSS_SALES",
        GET_NET_SALES: "SAGA_ACTIONS/DASHBOARD/GET_NET_SALES",
        GET_COST_OF_GOODS_SOLD: "SAGA_ACTIONS/DASHBOARD/GET_COST_OF_GOODS_SOLD",
        GET_GROSS_MARGIN: "SAGA_ACTIONS/DASHBOARD/GET_GROSS_MARGIN",
        GET_LABOR_COST: "SAGA_ACTIONS/DASHBOARD/GET_LABOR_COST",
        GET_NUM_OF_TRANSACTIONS: "SAGA_ACTIONS/DASHBOARD/GET_NUM_OF_TRANSACTIONS",
        GET_LOW_PERFORMING_PRODUCTS: "SAGA_ACTIONS/DASHBOARD/GET_LOW_PERFORMING_PRODUCTS",
    },
    FEEDBACK: {
        GET_CUSTOMER_FEEDBACK_DETAILS: "SAGA_ACTIONS/FEEDBACK/GET_CUSTOMER_FEEDBACK_DETAILS",
        INSERT_FEEDBACK: "SAGA_ACTIONS/FEEDBACK/INSERT_FEEDBACK",
        GET_FEEDBACK_LIST: "SAGA_ACTIONS/FEEDBACK/GET_FEEDBACK_LIST",
        GET_SETTINGS: "SAGA_ACTIONS/FEEDBACK/GET_SETTINGS",
        SAVE_SETTINGS: "SAGA_ACTIONS/FEEDBACK/SAVE_SETTINGS",
    },
    PRODUCT_IMPORT: {
        IMPORT_PRODUCTS: "SAGA_ACTIONS/PRODUCT_IMPORT/IMPORT_PRODUCTS",
    },

    // Marketing Automation
    MARKETING_CAMPAIGN: {
        SEARCH: "SAGA_ACTIONS/MARKETING_CAMPAIGN/SEARCH",
        INSERT_UPDATE: "SAGA_ACTIONS/MARKETING_CAMPAIGN/INSERT_UPDATE",
        DELETE: "SAGA_ACTIONS/MARKETING_CAMPAIGN/DELETE",
        DETAILS: "SAGA_ACTIONS/MARKETING_CAMPAIGN/DETAILS",
        DELIVERIES: "SAGA_ACTIONS/MARKETING_CAMPAIGN/DELIVERIES",
    },
    MARKETING_AUDIENCE_LIST: {
        SEARCH: "SAGA_ACTIONS/MARKETING_AUDIENCE_LIST/SEARCH",
        INSERT_UPDATE: "SAGA_ACTIONS/MARKETING_AUDIENCE_LIST/INSERT_UPDATE",
        DELETE: "SAGA_ACTIONS/MARKETING_AUDIENCE_LIST/DELETE",
        DETAILS: "SAGA_ACTIONS/MARKETING_AUDIENCE_LIST/DETAILS",
        BULK_UPSERT_MEMBERS: "SAGA_ACTIONS/MARKETING_AUDIENCE_LIST/BULK_UPSERT_MEMBERS",
        ADD_FROM_GROUPS: "SAGA_ACTIONS/MARKETING_AUDIENCE_LIST/ADD_FROM_GROUPS",
    },
    MARKETING: {
        MASTER_TAGS: "SAGA_ACTIONS/MARKETING/MASTER_TAGS",
        VALIDATE_TAGS: "SAGA_ACTIONS/MARKETING/VALIDATE_TAGS",
        PREVIEW_CONTENT: "SAGA_ACTIONS/MARKETING/PREVIEW_CONTENT",
        GET_SETTINGS: "SAGA_ACTIONS/MARKETING/GET_SETTINGS",
        SAVE_EMAIL_SETTINGS: "SAGA_ACTIONS/MARKETING/SAVE_EMAIL_SETTINGS",
        SAVE_SMS_SETTINGS: "SAGA_ACTIONS/MARKETING/SAVE_SMS_SETTINGS",
    },
    LOTTERY: {
        SEARCH: "SAGA_ACTIONS/LOTTERY/SEARCH",
        DETAILS: "SAGA_ACTIONS/LOTTERY/DETAILS",
        INSERT_UPDATE: "SAGA_ACTIONS/LOTTERY/INSERT_UPDATE",
        DELETE: "SAGA_ACTIONS/LOTTERY/DELETE",
        TICKET_SEARCH: "SAGA_ACTIONS/LOTTERY/TICKET_SEARCH",
        TICKET_EXPORT: "SAGA_ACTIONS/LOTTERY/TICKET_EXPORT",
        BOOKLET_DELETE: "SAGA_ACTIONS/LOTTERY/BOOKLET_DELETE",
        CHECK_BOOKLET_UNIQUE: "SAGA_ACTIONS/LOTTERY/CHECK_BOOKLET_UNIQUE",
        LOOKUP_BARCODE: "SAGA_ACTIONS/LOTTERY/LOOKUP_BARCODE",
        BOOKLET_PARSED_ADD: "SAGA_ACTIONS/LOTTERY/BOOKLET_PARSED_ADD",
    },
    DEPOSITS: {
        GET: "SAGA_ACTIONS/DEPOSITS/GET",
        ADD: "SAGA_ACTIONS/DEPOSITS/ADD",
        UPDATE: "SAGA_ACTIONS/DEPOSITS/UPDATE",
        DELETE: "SAGA_ACTIONS/DEPOSITS/DELETE",
    },
    QUICKBOOKS: {
        SETUP_STATUS: "SAGA_ACTIONS/QUICKBOOKS/SETUP_STATUS",
        SAVE_SETUP: "SAGA_ACTIONS/QUICKBOOKS/SAVE_SETUP",
        CONNECT: "SAGA_ACTIONS/QUICKBOOKS/CONNECT",
        DISCONNECT: "SAGA_ACTIONS/QUICKBOOKS/DISCONNECT",
        DELETE_SETUP: "SAGA_ACTIONS/QUICKBOOKS/DELETE_SETUP",
        MANUAL_SYNC_STATUS: "SAGA_ACTIONS/QUICKBOOKS/MANUAL_SYNC_STATUS",
        MANUAL_SYNC_TRIGGER: "SAGA_ACTIONS/QUICKBOOKS/MANUAL_SYNC_TRIGGER",
        MANUAL_SYNC_LOG: "SAGA_ACTIONS/QUICKBOOKS/MANUAL_SYNC_LOG",
        MANUAL_SYNC_RETRY: "SAGA_ACTIONS/QUICKBOOKS/MANUAL_SYNC_RETRY",
        OUTBOX_STATUS: "SAGA_ACTIONS/QUICKBOOKS/OUTBOX_STATUS",
        OUTBOX_LOG: "SAGA_ACTIONS/QUICKBOOKS/OUTBOX_LOG",
        OUTBOX_RETRY: "SAGA_ACTIONS/QUICKBOOKS/OUTBOX_RETRY",
        OUTBOX_RETRY_ALL: "SAGA_ACTIONS/QUICKBOOKS/OUTBOX_RETRY_ALL",
    },
};
